export default {
  common_share: `分享`,
  common_share_short: `分享`,
  common_notice: `公告`,
  common_notification: `通知`,
  common_download: `下載`,
  common_download_plural: `下載`,
  common_update: `更新`,
  common_update_now: `現在更新`,
  common_cancel: `取消`,
  common_close: `關閉`,
  common_ok: `確認`,
  common_confirm: `確定`,
  common_yes: `是`,
  common_no: `否`,
  common_save: `儲存`,
  common_error_retry: `重試一次`,
  common_login: `登入`,
  common_logout: `登出`,
  common_copy: `複製`,
  common_refresh: `重新整理`,
  common_delete: `刪除`,
  common_fix: `編輯`,
  common_service_version: `版本`,
  common_edit: `編輯`,
  common_language: `語言`,
  common_language_english: `English`,
  common_language_korean: `한국어`,
  common_language_zh_hant: `繁體中文`,
  common_language_thai: `ภาษาไทย`,
  common_language_indonesia: `Bahasa Indonesia`,
  common_language_french: `Français`,
  common_content_season: `season`,
  common_content_season_plural: `seasons`,
  common_content_episode: `話次`,
  common_content_episode_plural: `話次`,
  common_content_episode_value_short: `第{{value}}話`,
  common_episode_count: `{{count}}話`,
  common_episode_count_plural: `{{count}}話`,
  common_content_favorite: `加到最愛`,
  common_content_tag: `Tag`,
  common_content_like: `讚`,
  common_content_like_plural: `讚`,
  common_universe: `作品宇宙`,
  common_universe_circle: `作品宇宙`,
  common_viewer_alive: `ALIVE viewer`,
  common_matching_ai: `AI推薦`,
  common_matching_special: `特別推薦`,
  common_free: `免費`,
  common_paid: `付費`,
  common_rental: `借閱`,
  common_gidamu: `倒數免費`,
  common_gidamu_plus: `{{value}}小時`,
  common_gidamu_plus_long: `每{{value}}小時免費`,
  common_ongoing_free: `免費看`,
  common_free_available: `免費閱讀`,
  common_now_charging: `儲值中`,
  common_tab_library: `我的漫畫`,
  common_tab_ranking: `排行榜`,
  common_tab_giftbox: `禮物盒`,
  common_tab_service_name: `KAKAO WEBTOON`,
  common_tab_time_table_global: `星期列表`,
  common_tab_gidamu_plus: `倒數免費 +`,
  common_cash: `金幣`,
  common_cash_amount: `{{value}}金幣`,
  common_cash_currency: `NT\${{value}}`,
  common_cash_currency_symbol: `NT$`,
  common_ticket_amount: `{{count}}張`,
  common_ticket_amount_plural: `{{count}}張`,
  common_cash_purchased: `購買金幣`,
  common_cash_gift: `免費金幣`,
  common_ticket: `閱讀券`,
  common_ticket_plural: `閱讀券`,
  common_ticket_possession: `收藏券`,
  common_ticket_possession_plural: `收藏券`,
  common_ticket_possession_amount: `收藏券 {{count}}張`,
  common_ticket_possession_amount_plural: `收藏券 {{count}}張`,
  common_ticket_rental: `借閱券`,
  common_ticket_rental_plural: `借閱券`,
  common_ticket_rental_amount: `借閱券 {{count}}張`,
  common_ticket_rental_amount_plural: `借閱券 {{count}}張`,
  common_ticket_gift: `免費閱讀券`,
  common_ticket_gift_plural: `免費閱讀券`,
  common_ticket_gift_amount: `免費閱讀券 {{count}}張`,
  common_ticket_gift_amount_plural: `免費閱讀券 {{count}}張`,
  common_ticket_gidamu: `倒數免費券`,
  common_ticket_gidamu_plural: `倒數免費券`,
  common_ticket_gidamu_amount: `倒數免費券 {{count}}張`,
  common_ticket_gidamu_amount_plural: `倒數免費券 {{count}}張`,
  common_expired: `已到期`,
  common_add: `儲值`,
  common_purchase: `購買`,
  common_refund: `退款`,
  common_refund_past: `已退款`,
  common_use: `使用`,
  common_use_past: `已使用`,
  common_purchased: `已購買`,
  common_crm_slot_ticket: `抽獎券`,
  common_crm_slot_ticket_plural: `抽獎券`,
  common_crm_reservation: `事前預約`,
  common_bm_gidamu: `倒數免費`,
  common_bm_preview: `搶先看`,
  common_genre_all: `全部`,
  common_genre_romance: `愛情`,
  common_genre_romance_fantasy: `奇幻愛情`,
  common_genre_comedy: `搞笑`,
  common_genre_action: `動作`,
  common_genre_fantasy: `奇幻`,
  common_genre_thriller_horror: `懸疑恐怖`,
  common_genre_bl: `BL,GL`,
  common_genre_drama: `劇情`,
  common_schedule_daily: `星期列表`,
  common_schedule_new: `新作`,
  common_schedule_mon: `一`,
  common_schedule_tue: `二`,
  common_schedule_wed: `三`,
  common_schedule_thu: `四`,
  common_schedule_fri: `五`,
  common_schedule_sat: `六`,
  common_schedule_sun: `日`,
  common_schedule_completed: `完結`,
  common_time_year_ago: `{{count}}年前`,
  common_time_year_ago_plural: `{{count}}年前`,
  common_time_month_ago: `{{count}}月前`,
  common_time_month_ago_plural: `{{count}}月前`,
  common_time_day_ago: `{{count}}日前`,
  common_time_day_ago_plural: `{{count}}日前`,
  common_time_hour_ago: `{{count}}小時前`,
  common_time_hour_ago_plural: `{{count}}小時前`,
  common_time_minute_ago: `{{count}}分前`,
  common_time_minute_ago_plural: `{{count}}分前`,
  common_time_second_ago: `剛剛`,
  common_now: `現在`,
  common_period_year: `{{count}}年`,
  common_period_year_plural: `{{count}}年`,
  common_period_month: `{{count}}月`,
  common_period_month_plural: `{{count}}月`,
  common_period_day: `{{count}}日`,
  common_period_day_plural: `{{count}}日`,
  common_period_hour: `{{count}}小時`,
  common_period_hour_plural: `{{count}}小時`,
  common_period_minute: `{{count}}分`,
  common_period_minute_plural: `{{count}}分`,
  common_period_year_short: `{{count}}年`,
  common_period_year_short_plural: `{{count}}年`,
  common_period_month_short: `{{count}}月`,
  common_period_month_short_plural: `{{count}}月`,
  common_period_day_short: `{{count}}日`,
  common_period_day_short_plural: `{{count}}日`,
  common_period_hour_short: `{{count}}小時`,
  common_period_hour_short_plural: `{{count}}小時`,
  common_period_minute_short: `{{count}}分`,
  common_period_minute_short_plural: `{{count}}分`,
  common_period_second_short: `{{count}}秒`,
  common_period_second_short_plural: `{{count}}秒`,
  common_time_left: `剩餘{{value}}`,
  common_time_ago: `{{value}}前`,
  common_stroage_kb: `{{value}} KB`,
  common_stroage_mb: `{{value}} MB`,
  common_stroage_gb: `{{value}} GB`,
  common_service_name: `KAKAO WEBTOON`,
  common_not_select: `不設定`,
  common_kakaowebtoon: `KAKAO WEBTOON`,
  common_tab_home: `首頁`,
  recomm_tab_recommendations: `推薦`,
  recomm_tab_special: `強檔鉅獻`,
  recomm_tab_gidamu: `倒數免費 +`,
  recomm_top_100: `TOP 100`,
  recomm_tab_gidamu_description: `每{{hour}}小時就可獲得 <grey-bold>倒數免費券</grey-bold>。作品更新不間斷，現在立刻免費看！`,
  recomm_label_gidamu: `每{{value}}小時免費看`,
  top_guide_popup: `倒數免費通知
由此確認!`,
  recomm_label_popular: `人氣作品`,
  recomm_label_completed_nearly: `即將完結`,
  recomm_label_completed_nearly_detail: `預計完結`,
  recomm_label_upcoming: `近期上架`,
  recomm_label_trailer: `電影預告`,
  recomm_label_original_movie: `電影原著`,
  recomm_label_original_drama: `戲劇原著`,
  recomm_label_event: `活動`,
  recomm_label_event_detail_gift: `免費金幣`,
  recomm_label_event_detail_max: `最多可獲得`,
  recomm_label_ticket_detail: `{{value}}張`,
  recomm_label_ticket_detail_v4: `獲得{{value}}張`,
  recomm_label_ticket_detail_gift: `免費閱讀券`,
  recomm_label_legend: `經典`,
  recomm_label_new_detail: `觀看次數`,
  recomm_label_popular_detail: `累積觀看次數`,
  recomm_label_recommendation: `AI推薦`,
  common_tab_top: `HOME`,
  common_tab_hot: `熱門推薦`,
  ranking_tab_weekly: `週榜`,
  ranking_tab_daily: `日榜`,
  ranking_tab_real_time: `即時榜`,
  ranking_in_progress: `排名重新整理中`,
  ranking_badge_new: `NEW`,
  ranking_criteria_popup_title: `排行計算方式`,
  ranking_criteria_popup_contents: `KAKAO WEBTOON的所有排行榜皆以小時為單位，依據前一小時的閱覽及購買等使用者數據進行統計。`,
  common_tab_category: `探索`,
  category_tab_ranking: `排行榜`,
  category_tab_ranking_weekly: `週榜`,
  category_tab_ranking_daily: `日榜`,
  category_tab_ranking_real_time: `即時榜`,
  category_tab_ranking_in_progress: `排名重新整理中`,
  category_tab_ranking_badge_new: `NEW`,
  category_tab_new: `新作`,
  category_tab_ongoing: `連載中`,
  category_tab_completed: `完結`,
  common_tab_original_webtoon: `網漫原著`,
  common_tab_original_novel: `小說原著`,
  schedule_new_today: `今天`,
  schedule_genre_filter_all: `全部`,
  schedule_monday: `星期一`,
  schedule_tuesday: `星期二`,
  schedule_wednesday: `星期三`,
  schedule_thursday: `星期四`,
  schedule_friday: `星期五`,
  schedule_saturday: `星期六`,
  schedule_sunday: `星期日`,
  schedule_empty: `目前沒有登錄的作品`,
  schedule_completed_label_legend: `經典作品`,
  schedule_completed_label_pd: `PD推薦`,
  schedule_completed_label_trailer: `電影預告`,
  schedule_completed_label_recommendation: `推薦`,
  schedule_completed_label_magazine: `追漫誌`,
  schedule_completed_label_cashback: `金幣回饋`,
  schedule_two_column: `兩欄模式`,
  schedule_three_column: `三欄模式`,
  schedule_four_column: `四欄模式`,
  schedule_two_column_selected: `以兩欄顯示`,
  schedule_three_column_selected: `以三欄顯示`,
  schedule_four_column_selected: `以四欄顯示`,
  schedule_sort_guide: `目前是以星期分類連載中的作品，
您可以依照想要的順序來排列目錄`,
  schedule_guide_popup: `可變更目錄類型`,
  schedule_sort_title: `選擇排序`,
  schedule_sort_recommend: `依推薦排序`,
  schedule_sort_early_access: `依免費看排序`,
  schedule_sort_gidamu: `依倒數免費排序`,
  schedule_sort_gidamu_short: `依倒數免費時間排序`,
  schedule_sort_not_provided_toast: `目前僅能依推薦排序`,
  schedule_genre_select_popup: `選擇類型`,
  login_action_view_next_episode_popup: `欲繼續閱覽
請先登入。`,
  contenthome_wifi_popup: `目前並未使用Wi-Fi連線。
您要使用行動數據閱覽嗎？`,
  contenthome_ticketused_possession_snackbar: `已使用 {{value}}張收藏券`,
  contenthome_ticketused_rental_snackbar: `已使用 {{value}}張借閱券`,
  contenthome_ticketused_gift_snackbar: `已使用 {{value}}張免費閱讀券`,
  contenthome_ticketused_gidamu_snackbar: `已使用 {{value}}張倒數免費券`,
  contenthome_ticket_option_popup: `請選擇要使用的閱讀券`,
  contenthome_popup_rent_button: `借閱券`,
  contenthome_popup_possess_button: `收藏券`,
  contenthome_ticket_remaining: `借閱券：{{rental}}張 / 收藏券：{{possess}}張`,
  contenthome_ticket_remaining_rental_plural: `借閱券：{{rental}}張 / 收藏券：{{possess}}張`,
  contenthome_ticket_remaining_possession_plural: `借閱券：{{rental}}張 / 收藏券：{{possess}}張`,
  contenthome_ticket_remaining_plural: `借閱券：{{rental}}張 / 收藏券：{{possess}}張`,
  contenthome_popup_ticket_rental: `借閱券：{{count}}張`,
  contenthome_popup_ticket_rental_plural: `借閱券：{{count}}張`,
  contenthome_popup_ticket_possession: `收藏券：{{count}}張`,
  contenthome_popup_ticket_possession_plural: `收藏券：{{count}}張`,
  contenthome_latest_ep_ticket_popup: `最新{{value}}話
無法使用倒數免費券。
是否要選擇其他閱讀券？`,
  contenthome_latest_ep_ticket_rental_popup: `最新{{value}}話
無法使用倒數免費券，
將使用借閱券。`,
  contenthome_latest_ep_ticket_possession_popup: `最新{{value}}話
無法使用倒數免費券。
是否要使用收藏券？`,
  contenthome_not_gidamu_ep_ticket_popup: `該話次無法使用倒數免費券。
是否要使用其他閱讀券？`,
  contenthome_not_gidamu_ep_ticket_rental_popup: `該話次無法使用倒數免費券，
將使用借閱券。`,
  contenthome_not_gidamu_ep_ticket_possession_popup: `該話次無法使用倒數免費券，
將使用收藏券。`,
  contenthome_rented_ep_ticket_rental_popup: `您曾借閱過該話次，
將再次使用借閱券。`,
  contenthome_rented_ep_ticket_possession_popup: `您曾借閱過該話次。
將使用收藏券。`,
  contenthome_rented_ep_ticket_gift_popup: `您曾借閱過該話次，
將使用免費閱讀券。`,
  contenthome_rented_ep_ticket_gidamu_popup: `您曾借閱過該話次，
將使用倒數免費券。`,
  contenthome_rented_ep_ticket_popup: `您曾借閱過該話次。
是否要使用閱讀券？`,
  contenthome_rented_ep_purchase_ticket_popup: `您曾借閱過該話次。
是否要購買閱讀券？`,
  contenthome_expired_popup: `借閱期間已到期，無法繼續閱覽。
請選擇想閱覽的話次。`,
  contenthome_expired_popup_viewed_button: `已閱覽的話次`,
  contenthome_expired_popup_next_button: `下一話`,
  contenthome_latest_expired_ticket_rental_popup: `您曾借閱過該最新 {{value}}話，
該話次無法使用倒數免費券，
將再次使用借閱券。`,
  contenthome_latest_expired_ticket_possession_popup: `您曾借閱過該最新 {{value}}話
該話次無法使用倒數免費券。
是否要使用收藏券？`,
  contenthome_latest_expired_ticket_popup: `您曾借閱過該最新 {{value}}話
該話次無法使用倒數免費券。
是否要使用其他閱讀券？`,
  contenthome_stop_sell_popup: `無法閱覽停止販售之話次`,
  contenthome_ticketused_gift_popup: `將使用免費閱讀券`,
  contenthome_ticketused_rental_popup: `將使用借閱券`,
  contenthome_ticketused_possession_popup: `將使用收藏券`,
  contenthome_ticketused_gidamu_popup: `將使用倒數免費券`,
  contenthome_latest_ep_gidamu_popup: `該話次無法使用倒數免費券`,
  contenthome_universe_matching: `《{{title}}》及其他{{matching}}`,
  contenthome_universe_similar_title: `相似的作品`,
  contenthome_universe_similar_drawing: `畫風類似的作品`,
  contenthome_universe_same_genre: `同為{{genre}}類的作品`,
  contenthome_universe_today_popular: `今日最多人瀏覽的作品`,
  contenthome_universe_today_favorite: `今日最多人收藏的作品`,
  contenthome_gift_rental_popup: `獲得 {{count}}張免費閱讀券`,
  contenthome_gift_rental_popup_plural: `獲得 {{count}}張免費閱讀券`,
  contenthome_gift_rental_valid_until_popup: `使用期限：發送日起3天`,
  contenthome_expiry_specific_date: `使用期限：至 {{value}}止`,
  contenthome_fav_notification_popup_title: `已成功新增至我的最愛`,
  contenthome_fav_notification_popup_content: `更新時會發送推播通知。
您可以在「我的漫畫 > 我的最愛」管理推播通知。`,
  contenthome_fav_undo_toast: `已從我的最愛中移除`,
  contenthome_ticketbar_ticket: `閱讀券 {{count}}張`,
  contenthome_ticketbar_ticket_plural: `閱讀券 {{count}}張`,
  contenthome_ticketbar_newbie_ticket: `註冊好禮閱讀券 {{count}}張`,
  contenthome_ticketbar_newbie_ticket_plural: `註冊好禮閱讀券 {{count}}張`,
  contenthome_ticketbar_gidamu: `每 {{count}}日免費看`,
  contenthome_ticketbar_gidamu_plural: `每 {{count}}日免費看`,
  contenthome_ticketbar_gidamu_hour: `每 {{count}}小時免費看`,
  contenthome_ticketbar_gidamu_hour_plural: `每 {{count}}小時免費看`,
  contenthome_ticketbar_gidamu_minute: `每 {{count}}分免費看`,
  contenthome_ticketbar_gidamu_minute_plural: `每 {{count}}分免費看`,
  contenthome_ticketbar_gidamu_full: `倒數完畢`,
  contenthome_ticketbar_ep_free: `{{count}}話免費`,
  contenthome_ticketbar_ep_free_plural: `{{count}}話免費`,
  contenthome_ticketbar_all_free: `全話次免費`,
  contenthome_ticketbar_charged: `倒數完畢`,
  contenthome_ticketbar_charging: `{{value}}後倒數完畢`,
  contenthome_ticketbar_preview: `{{count}}話搶先看`,
  contenthome_ticketbar_preview_plural: `{{count}}話搶先看`,
  contenthome_ticketbar_unavailable: `停止販售`,
  contenthome_guide_popup: `向左滑動看相關推薦作品，
向下滑動探索更多種類的作品。`,
  contenthome_total: `總話數`,
  contenthome_first_episode_tab_button: `看第一話`,
  contenthome_first_episode_tab_continue: `繼續閱讀第一話`,
  contenthome_first_episode_tab_guide: `現在立刻往下看。`,
  contenthome_first_episode_tab_content: `好奇接下來的劇情嗎？`,
  contenthome_first_episode_tab_page_only: `本作品可使用左右翻模式閱覽，
您要切換模式嗎？`,
  contenthome_first_episode_tab_paid: `此為付費話次，
您要使用閱讀券嗎？`,
  contenthome_first_episode_tab_stop_sell: `該作品目前停止販售`,
  contenthome_first_episode_tab_related_novel: `相關小說`,
  contenthome_first_episode_tab_viewer: `繼續閱讀完整內容`,
  contenthome_continue_episode_tab_last_read: `{{value}}已閱讀過本話次`,
  contenthome_continue_episode_tab_last_episode: `目前沒有下一話`,
  contenthome_continue_episode_tab_stop_sell: `該話次目前停止販售`,
  contenthome_continue_next_episode: `繼續看 {{value}}`,
  contenthome_continue_last_episode: `目前沒有下一話`,
  contenthome_episode_tab_button: `話次`,
  contenthome_preview_day: `{{count}}日後免費看`,
  contenthome_preview_day_plural: `{{count}}日後免費看`,
  contenthome_ep_tab_order_latest_snackbar: `以最新話次排序`,
  contenthome_ep_tab_order_chronological_snackbar: `以上架日期排序`,
  contenthome_ep_tab_first_episode_button: `看第一話`,
  contenthome_ep_tab_continue_episode_button: `繼續看 {{value}}`,
  contenthome_ep_tab_continue_without_episode_button: `繼續看`,
  contenthome_ep_tab_back_top_button: `回到頂端`,
  contenthome_alive_unzipping: `檔案處理中...`,
  contenthome_alive_download_popup_title: `ALIVE為最新網漫閱覽器。
請開啟聲音一起觀賞。`,
  contenthome_storage_full_popup_title: `裝置容量不足`,
  contenthome_storage_full_popup_content: `請確認裝置容量後重試一次`,
  contenthome_alive_fail_unzip_popup_title: `檔案解壓縮失敗`,
  contenthome_alive_fail_unzip_popup_content: `請重新下載檔案`,
  contenthome_ep_tab_stop_sell_popup: `該話次目前已停止販售，無法閱覽。`,
  contenthome_ep_expired: `借閱已到期`,
  contenthome_ep_tab_type_thumbnail: `以縮圖檢視`,
  contenthome_ep_tab_type_list: `以清單檢視`,
  contenthome_ep_tab_order_latest: `以最新話次排序`,
  contenthome_ep_tab_order_chronological: `以上架日期排序`,
  contenthome_ep_tab_type_thumbnail_toast: `以縮圖檢視`,
  contenthome_ep_tab_type_list_toast: `以清單檢視`,
  contenthome_ep_tab_download_guide_popup: `使用清單檢視模式，可下載話次`,
  contenthome_ep_tab_type_popup_title: `您可以使用清單檢視模式，\n下載話次與閱覽漫畫。`,
  contenthome_info_tab_button: `作品資訊`,
  contenthome_info_tab_author: `文`,
  contenthome_info_tab_illustrator: `圖`,
  contenthome_info_tab_original: `原著`,
  contenthome_info_tab_adaptation: `改編`,
  contenthome_info_tab_color: `上色`,
  contenthome_info_tab_publisher: `發行`,
  contenthome_info_tab_summary: `故事大綱`,
  contenthome_info_tab_more_button: `看更多`,
  contenthome_info_tab_keywords: `關鍵字`,
  contenthome_info_tab_video: `影片`,
  contenthome_info_tab_video_v4: `相關影片`,
  contenthome_info_tab_teaser: `預告片`,
  contenthome_info_tab_special: `特別鉅獻`,
  contenthome_info_tab_rec_author: `{{author}}的其他作品`,
  viewer_end_recommendation: `相似的作品`,
  contenthome_ticket_tab_button: `閱讀券`,
  contenthome_ticket_tab_gift_ticket_1: `EVENT `,
  contenthome_ticket_tab_gift_ticket_2: `免費閱讀券 {{value}}張`,
  contenthome_ticket_tab_gift_ticket_button: `領取`,
  contenthome_ticket_tab_gift_ticket_remaining: `現有閱讀券`,
  contenthome_ticket_tab_ticket_purchase_button: `購買`,
  contenthome_ticket_tab_ticket_history: `閱讀券使用紀錄`,
  contenthome_ticket_tab_ticket_count: `{{count}}張`,
  contenthome_ticket_tab_ticket_count_plural: `{{count}}張`,
  contenthome_comment_tab_button: `留言`,
  comment_order_recent_snackbar: `以最新留言排序`,
  comment_order_likes_snackbar: `以讚數排序`,
  comment_order_recent: `以最新留言排序`,
  comment_order_likes: `以讚數排序`,
  contenthome_comment_empty: `目前尚無留言`,
  contenthome_tickethistory: `閱讀券使用紀錄`,
  contenthome_sidemenu_notice: `作品公告`,
  contenthome_sidemenu_clearhistory: `刪除所有觀看紀錄`,
  contenthome_sidemenu_share: `分享作品`,
  share_popup_title: `分享`,
  share_link_copied_paste_toast: `連結已複製。
立刻分享給好友。`,
  contenthome_sidemenu_download_autodelete: `請至「我的漫畫 > 下載」管理話次`,
  contenthome_sidemenu_download_available: `可下載`,
  contenthome_sidemenu_download_waiting: `等待下載中`,
  contenthome_sidemenu_download_complete: `下載完成`,
  contenthome_sidemenu_download_purchase: `購買後進行下載`,
  contenthome_sidemenu_download_fail: `下載失敗`,
  contenthome_sidemenu_register_popup_title: `是否要登錄目前的裝置？`,
  contenthome_sidemenu_register_popup_content: `下載僅限於已登錄的裝置進行，目前使用的裝置尚未登錄。每個ID可以登錄2台裝置，每月可變更1次。`,
  settings_device_register_impossible_exceed_popup_title: `裝置登錄變更次數已達上限，無法再進行登錄。`,
  settings_device_register_impossible_exceed_popup_content: `變更登錄裝置每月僅限1次。`,
  settings_device_register_exceed_popup: `可登錄的裝置數已達上限。請先註銷其中1台裝置，方可登錄新裝置。`,
  settings_device: `管理登錄裝置`,
  contenthome_sidemenu_download_data_popup_title: `是否要使用行動數據下載？`,
  contenthome_sidemenu_download_data_popup_content: `目前尚未使用Wi-Fi連線。
根據行動數據的收費制度，可能產生額外費用。`,
  contenthome_sidemenu_download_complete_popup_title: `《{{title}}》下載成功`,
  contenthome_sidemenu_download_complete_popup_content: `成功下載{{episode}}`,
  contenthome_sidemenu_download_complete_popup_content_plural: `成功下載{{count}}個話次`,
  contenthome_sidemenu_download_fail_popup_title: `《{{title}}》下載失敗`,
  contenthome_sidemenu_download_fail_popup_content: `{{episode}}下載失敗`,
  contenthome_sidemenu_download_fail_popup_content_plural: `{{count}}個話次下載失敗`,
  notification_notice_list_blank: `沒有新公告`,
  contenthome_sidemenu_clearhistory_deleted: `已刪除觀看紀錄`,
  contenthome_universe_matching_exploring: `探索中`,
  contenthome_universe_matching_type_ai: `AI推薦`,
  contenthome_universe_title: `《{{title}}》和`,
  contenthome_universe_matching_type_ai_similar: `和《{{title}}》
相似的作品`,
  contenthome_universe_matching_type_ai_drawing: `和《{{title}}》
畫風類似的作品`,
  contenthome_universe_matching_type_ai_genre: `和《{{title}}》
同為{{genre}}類的作品`,
  contenthome_universe_matching_type_special: `特別推薦`,
  contenthome_universe_matching_type_special_other: `《{{title}}》及其他{{matching}}`,
  contenthome_universe_matching_type_today: `今日推薦`,
  contenthome_universe_matching_type_today_mostviewed: `今日最多人瀏覽的作品`,
  contenthome_universe_matching_type_today_mostpopular: `今日最多人收藏的作品`,
  contenthome_universe_matching_type_nextup: `下個推薦類型是{{type}}`,
  contenthome_universe_matching_blank: `沒有相符的作品宇宙`,
  contenthome_universe_matching_first: `第一部作品`,
  contenthome_universe_matching_last: `最後一部作品`,
  contenthome_stop_sell_refund_popup: `該作品目前停止販售。
未使用的閱讀券是否申請退款？`,
  contenthome_stop_sell_toast: `該作品目前停止販售`,
  contenthome_prohibited_sell_popup: `該作品目前已停止販售，無法閱覽。`,
  contenthome_tickethistory_purchased: `儲值明細`,
  contenthome_tickethistory_used: `使用紀錄`,
  contenthome_tickethistory_gidamu_minute: `每{{count}}分免費獲得1張`,
  contenthome_tickethistory_gidamu_minute_plural: `每{{count}}分免費獲得1張`,
  contenthome_tickethistory_gidamu_day: `每{{count}}日免費獲得1張`,
  contenthome_tickethistory_gidamu_day_plural: `每{{count}}日免費獲得1張`,
  contenthome_tickethistory_gidamu_hour: `每{{count}}小時免費獲得1張`,
  contenthome_tickethistory_gidamu_hour_plural: `每{{count}}小時免費獲得1張`,
  contenthome_tickethistory_popup_detail_minute_1: `使用倒數免費券 {{count}}分後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_minute_1_plural: `使用倒數免費券 {{count}}分後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_hour_1: `使用倒數免費券 {{count}}小時後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_hour_1_plural: `使用倒數免費券 {{count}}小時後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_day_1: `使用倒數免費券 {{count}}天後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_day_1_plural: `使用倒數免費券 {{count}}天後可獲得1張閱讀券`,
  contenthome_tickethistory_popup_detail_2: `最新 {{value}}話(包含免費話次)無法使用倒數免費閱覽`,
  contenthome_tickethistory_popup_detail_3: `使用倒數免費券的話次可於3日內閱覽`,
  contenthome_tickethistory_gift_event: `活動好禮`,
  ticket_history_used_newbie: `註冊好禮`,
  contenthome_tickethistory_cancelled: `已取消`,
  contenthome_tickethistory_refund_title: `取消購買閱讀券`,
  contenthome_tickethistory_refund_purchase_info: `購買資訊`,
  contenthome_tickethistory_refund_purchase_info_date: `購買日期`,
  contenthome_tickethistory_refund_purchase_info_number: `訂單編號`,
  contenthome_tickethistory_refund_purchase_info_ticket: `購買閱讀券數量`,
  contenthome_tickethistory_refund_purchase_info_ticket_plural: `購買閱讀券數量`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus: `{{count}}張+贈送{{bonus}}張`,
  contenthome_tickethistory_refund_purchase_info_ticket_bonus_plural: `{{count}}張+贈送{{bonus}}張`,
  contenthome_tickethistory_refund_info: `退款資訊`,
  contenthome_tickethistory_refund_info_ticket: `可退款的閱讀券數量`,
  contenthome_tickethistory_refund_info_ticket_cash: `1張閱讀券的等值金幣`,
  contenthome_tickethistory_refund_info_cash: `退款金幣`,
  contenthome_tickethistory_refund_info_cash_expired: `已到期的免費金幣`,
  contenthome_tickethistory_refund_info_cash_able: `可退款金幣`,
  contenthome_tickethistory_refund_notice_price: `退款金幣說明`,
  contenthome_tickethistory_refund_notice_price_1: `實際可退款金額將扣除已到期的免費金幣。`,
  contenthome_tickethistory_refund_notice_price_2: `因免費金幣已過使用期限，實際退款金額與閱讀券明細可能有所差異。`,
  contenthome_tickethistory_refund_notice_policy: `退款政策`,
  contenthome_tickethistory_refund_notice_policy_1: `以免費金幣購買之閱讀券僅能在免費金幣未過期前進行退款。`,
  contenthome_tickethistory_refund_notice_policy_2: `「今天的閱讀券好禮」、「註冊好禮」、「一次性購買回饋閱讀券」等免費提供之閱讀券無法申請退款。`,
  contenthome_tickethistory_refund_notice_policy_3: `申請閱讀券退款時，僅能退還KAKAO WEBTOON金幣。`,
  contenthome_tickethistory_refund_notice_policy_4: `閱讀券退款申請無法撤回，請謹慎考慮後再提出。`,
  contenthome_tickethistory_refund_notice_policy_5: `退款相關事宜請洽客服中心。`,
  contenthome_tickethistory_refund_button: `取消購買閱讀券`,
  contenthome_tickethistory_refund_popup: `是否取消購買閱讀券？`,
  contenthome_tickethistory_refund_detail_popup: `取消閱讀券：{{ticket}}張 / 退款金幣：{{cash}}`,
  contenthome_tickethistory_refund_detail_popup_plural: `取消閱讀券：{{ticket}}張 / 退款金幣：{{cash}}`,
  contenthome_tickethistory_refund_snackbar: `已取消購買閱讀券`,
  contenthome_tickethistory_used_gift_event: `免費閱讀券 (活動好禮)`,
  contenthome_tickethistory_used_gift_newbie: `免費閱讀券 (註冊好禮)`,
  gift_ticket_fail_received_popup: `已領取禮物`,
  gift_ticket_fail_expired_popup: `可領取期限已到期`,
  viewer_capture_aos_snackbar: `基於保密條款，無法擷取螢幕畫面。`,
  viewer_capture_ios_popup_title: `著作權聲明`,
  viewer_capture_ios_popup_content: `存取作品截圖並於線上、線下分享或傳播有可能違反著作權法。所有截圖歷程可透過電子緝查系統即時追蹤，若確定有惡意散播之行徑，用戶將受法律制裁。`,
  viewer_record_snackbar: `基於保密條款，無法錄製螢幕畫面。`,
  viewer_stop_sale_popup: `無法閱覽停止販售之話次`,
  viewer_related_novel: `相關小說`,
  contenthome_alive_download_popup_content: `下載後即可閱覽
建議使用Wi-Fi下載`,
  viewer_marathon_viewing_snackbar: `開啟一路看模式。
必要時會自動使用閱讀券。`,
  viewer_marathon_viewing_last_ep_toast: `目前沒有下一話`,
  viewer_marathon_viewing_first_ep_toast: `沒有前一話`,
  viewer_marathon_viewing_guide_app: `開啟一路看模式，閱讀至最後，將自動載入下一話，讓您順暢K漫不間斷。`,
  viewer_end_gidamu_plus_info: `現在可以每{{value}}小時免費看
《{{contentname}}》!`,
  viewer_end_like_first: `快來搶首讚`,
  viewer_end_like_snackbar: `這部作品真的很讚吧!
每一話最多只能按5個讚哦~`,
  viewer_end_comment_count: `看 {{value}}則留言`,
  viewer_end_comment_count_zero: `0則留言`,
  viewer_end_comment_count_v4: `{{value}}則留言`,
  viewer_end_comment_button: `看更多留言`,
  viewer_end_next_button: `繼續看 <white>{{value}}</white>`,
  viewer_end_next_button_v4: `繼續看 {{value}}`,
  viewer_end_last_episode: `目前沒有下一話`,
  viewer_end_next_pull: `往上滑繼續看 <grey>{{value}}</grey>`,
  viewer_end_recommendation_v4: `類似的作品`,
  viewer_ep_list_free: `免費`,
  viewer_ep_list_gidamu: `倒數免費`,
  viewer_ep_list_rent: `借閱`,
  viewer_ep_list_possess: `收藏`,
  viewer_top_button: `回到頂端`,
  viewer_page_swipe_snackbar: `動動手指往左滑`,
  viewer_page_swipe_right_snackbar: `動動手指往右滑`,
  viewer_setting_zoom_button: `放大/縮小`,
  viewer_setting_preview_comment_button: `搶先看留言`,
  viewer_setting_remember_button: `記錄上次閱覽進度`,
  viewer_setting_autoscroll_button: `自動滑`,
  viewer_setting_autoscroll_button_v4: `自動滑速度`,
  viewer_setting_autoscroll_toast: `轉換為自動滑模式。\n可在設定內調整滑動速度。`,
  viewer_setting_bgm_button: `BGM`,
  viewer_setting_brightness: `螢幕亮度`,
  viewer_setting_share_ep_button: `分享本話次`,
  viewer_setting_capture_screen_button: `螢幕截圖`,
  viewer_setting_view_page_button: `左右翻`,
  viewer_setting_view_scroll_button: `上下滑`,
  viewer_setting_capture_button: `擷取螢幕`,
  viewer_setting_capture_saved: `已儲存至我的相簿`,
  viewer_setting_capture_access_required_popup: `欲存取螢幕畫面需開啟權限`,
  viewer_setting_capture_access_authorization_required: `欲存取螢幕畫面需開啟「KAKAO WEBTOON的照片存取權限」`,
  viewer_setting_hide_comment_off: `關閉隱藏留言功能`,
  viewer_setting_hide_comment_on: `開啟隱藏留言功能`,
  viewer_setting_enlarge_off: `關閉放大鏡`,
  viewer_setting_enlarge_on: `開啟放大鏡`,
  viewer_setting_last_viewed_off: `關閉紀錄上次閱覽進度功能`,
  viewer_setting_last_viewed_on: `開啟紀錄上次閱覽進度功能`,
  viewer_setting_sound_off: `關閉聲音`,
  viewer_setting_sound_on: `開啟聲音`,
  viewer_setting_view_page: `左右翻`,
  viewer_setting_view_scroll: `上下滑`,
  viewer_setting_view_page_switch_toast: `切換成左右翻`,
  viewer_setting_view_scroll_switch_toast: `切換成上下滑`,
  viewer_setting_enlarge_on_text: `輕觸畫面兩下即可放大/縮小`,
  viewer_setting_enlarge_off_text: `關閉放大/縮小功能`,
  viewer_setting_preview_comment_on_text: `可搶先看BEST留言`,
  viewer_setting_preview_comment_off_text: `關閉搶先看留言功能`,
  viewer_setting_last_viewed_on_text: `下次開啟時自動移至上次閱覽進度`,
  viewer_setting_last_viewed_off_text: `關閉記錄上次閱覽進度功能`,
  viewer_setting_autoscroll_on_text: `長按畫面即可開啟自動滑`,
  viewer_setting_autoscroll_off_text: `關閉自動滑功能`,
  viewer_setting_sound_on_text: `閱覽時播放BGM`,
  viewer_setting_sound_off_text: `關閉BGM`,
  viewer_onetouch_popup_title: `需購買閱讀券`,
  viewer_onetouch_popup_title_1_web: `欲繼續閱讀{{value}}，`,
  viewer_onetouch_popup_title_2_web: `需購買閱讀券`,
  viewer_onetouch_popup_title_ticket: `您要購買借閱券並繼續閱讀嗎?`,
  viewer_onetouch_popup_title_cash: `您要儲值並購買閱讀券嗎?`,
  viewer_onetouch_popup_subtitle_gidamu: `該話次無法使用倒數免費券`,
  viewer_onetouch_popup_content_balance: `現有金幣`,
  viewer_onetouch_popup_content_ticket: `借閱券(365日)`,
  viewer_onetouch_popup_button_ticket: `借閱`,
  viewer_onetouch_popup_button_cash: `儲值並借閱`,
  viewer_onetouch_popup_button_options: `其他借閱方案或收藏`,
  comment_title: `<bold>留言</bold> {{count}}`,
  comment_title_plural: `<bold>留言</bold> {{count}}`,
  comment_empty_first: `請寫下第一則留言`,
  comment_account_deleted: `已註銷會員`,
  comment_unknown_user: `未知的帳號`,
  comment_see_comment_spoiler: `此留言可能劇透`,
  comment_button_dislike: `噓`,
  comment_button_dislike_plural: `噓`,
  comment_reply_title: `<bold>回覆</bold> {{count}}`,
  comment_reply_title_plural: `<bold>回覆</bold> {{count}}`,
  comment_write_reply_title: `回覆留言`,
  comment_reply: `回覆`,
  comment_reply_plural: `回覆`,
  comment_button_delete: `刪除`,
  comment_button_delete_popup: `是否要刪除所選的留言？`,
  comment_deleted_toast: `此留言已被刪除`,
  comment_deleted_click_action_toast: `此留言已被刪除，無法完成您的要求。`,
  comment_button_report: `檢舉`,
  comment_report_already_report: `您已檢舉過此留言`,
  comment_before_enter: `請輸入留言`,
  comment_reply_before_enter: `請回覆留言`,
  comment_reply_more: `看其他回覆`,
  comment_button_enter: `輸入`,
  comment_button_block: `封鎖`,
  comment_block_popup_title: `您要封鎖{{nickname}}嗎？`,
  comment_block_popup_content: `封鎖後，您將無法看到該用戶的留言。`,
  comment_block_toast: `已封鎖該用戶`,
  comment_already_blocked_toast: `您已封鎖該用戶`,
  comment_already_unblocked_toast: `您已解除封鎖該用戶`,
  comment_block_displayed: `您已封鎖該用戶的留言`,
  comment_button_unblock: `解除封鎖`,
  comment_unblock_popup_title: `您要解除封鎖{{nickname}}嗎？`,
  comment_unblock_popup_content: `解除封鎖後，您將可以看到該用戶的留言。`,
  comment_unblock_toast: `已解除封鎖`,
  comment_write_title: `寫下留言`,
  comment_write_spoiler_button: `爆雷`,
  comment_write_snackbar: `留言送出後無法立即新增留言`,
  login_comment_write_popup: `登入後
方可留言`,
  login_comment_exceed_toast: `留言已超過限制字數`,
  comment_report_spam: `廣告訊息`,
  comment_report_violence: `暴力/騷擾/仇恨言論`,
  comment_report_illegal: `非法資訊`,
  comment_report_privacy: `個資外流`,
  comment_report_sexual: `裸露/煽情`,
  comment_report_repeatedly: `洗版`,
  comment_report_rights: `侵權申報`,
  comment_report_file_button: `上傳附件`,
  comment_report_other: `其他`,
  comment_report_other_inputbox: `請選擇「其他」後詳述問題`,
  comment_report_piracy_popup_title: `是否要繼續進行下一步？`,
  comment_report_submitted_toast_short: `檢舉內容已成功送出`,
  comment_report_submitted_toast: `檢舉內容已成功送出。
被檢舉的留言將依營運政策進行審核。`,
  comment_report_read_more_button: `更多`,
  comment_report_info: `請檢舉非法內容或對應用程式使用有負面影響的留言。被檢舉的留言會依據營運政策進行處理，若有不實檢舉的情形，用戶使用應用程式時可能受限。`,
  comment_report: `檢舉`,
  comment_report_button: `送出`,
  login_comment_report_popup: `登入後
方可檢舉`,
  comment_regulated: `受限的留言`,
  comment_regulated_content: `此留言含有目前受理侵權申報之內容。`,
  comment_regulated_popup_title: `已依據營運政策封鎖留言功能。`,
  comment_regulated_popup_date_range: `封鎖時間：{{start}}~{{end}}`,
  comment_regulated_popup_date_permanent: `封鎖時間：永久封鎖`,
  comment_regulated_popup_detail_1: `留言功能封鎖期間，除撰寫留言外其餘功能可正常使用。`,
  comment_regulated_popup_detail_2: `封鎖時間期滿將自動解除封鎖。`,
  comment_regulated_popup_detail_3: `若持續違反應用程式使用條款，可能加重處罰。`,
  comment_regulated_popup_detail_4: `若有任何問題，請洽客服中心。`,
  more_title_ticket_history: `閱讀券明細`,
  ticket_history_add_tab: `儲值明細`,
  cash_history_used_detail: `因免費金幣已過使用期限，實際退款金額與閱讀券明細可能有所差異。`,
  cash_history_used_rental: `購買 {{count}}張借閱券`,
  cash_history_used_rental_plural: `購買 {{count}}張借閱券`,
  cash_history_used_possession: `購買 {{count}}張收藏券`,
  cash_history_used_possession_plural: `購買 {{count}}張收藏券`,
  ticket_history_add_gift: `免費閱讀券 {{count}}張`,
  ticket_history_add_gift_plural: `免費閱讀券 {{count}}張`,
  ticket_history_add_gidamu: `1張倒數免費券`,
  cash_history_valid_date: `使用期限 {{date}}`,
  cash_history_used_rental_refunded: `取消購買 {{count}}張借閱券`,
  cash_history_used_rental_refunded_plural: `取消購買 {{count}}張借閱券`,
  cash_history_used_possession_refunded: `取消購買 {{count}}張收藏券`,
  cash_history_used_possession_refunded_plural: `取消購買 {{count}}張收藏券`,
  ticket_history_add_empty: `尚無儲值紀錄`,
  ticket_history_used_tab: `使用紀錄`,
  ticket_history_episode_range: `第{{start}} - {{end}}話`,
  ticket_history_used_empty: `尚無閱讀券使用紀錄`,
  ticket_purchase_title: `購買閱讀券`,
  ticket_purchase_title_detail: `以下所指閱讀券僅適用於本作品`,
  ticket_purchase_balance_rental: `現有借閱券`,
  ticket_purchase_balance_possession: `現有收藏券`,
  ticket_purchase_ep_unread: `尚未閱覽話次數 (不包含免費話次)`,
  ticket_purchase_balance_cash: `現有金幣`,
  ticket_purchase_ineligible: `該作品未販售閱讀券`,
  ticket_purchase_rental: `購買<purple>借閱券</purple>`,
  ticket_purchase_possession: `購買<blue>收藏券</blue>`,
  ticket_purchase_all: `一次性購買`,
  ticket_purchase_bonus_1: `{{count}}張`,
  ticket_purchase_bonus_1_plural: `{{count}}張`,
  ticket_purchase_bonus_2: ` + 贈送{{count}}張`,
  ticket_purchase_bonus_2_plural: ` + 贈送{{count}}張`,
  ticket_purchase_bonus_rental_2: `{{count}}張 <purple>+ 贈送{{bonus}}張</purple>`,
  ticket_purchase_bonus_rental_2_plural: `{{count}}張 <purple>+ 贈送{{bonus}}張</purple>`,
  ticket_purchase_bonus_possession_2: `{{count}}張 <blue>+ 贈送{{bonus}}張</blue>`,
  ticket_purchase_bonus_possession_2_plural: `{{count}}張 <blue>+ 贈送{{bonus}}張</blue>`,
  ticket_purchase_rental_regulation_1: `借閱期間：使用借閱券後365天內`,
  ticket_purchase_rental_regulation_2: `可於使用借閱券後的365天內閱讀`,
  ticket_purchase_cashfriend: `目前可獲得的金幣`,
  ticket_purchase_rental_discount: `借閱券優惠`,
  ticket_purchase_possession_discount: `收藏券優惠`,
  ticket_purchase_total_count: `總數`,
  ticket_purchase_total_price: `總金額`,
  ticket_purchase_total_regulation_1: `此閱讀券僅適用於本作品。`,
  ticket_purchase_total_regulation_2: `免費閱讀券無法進行退款。`,
  ticket_purchase_cancel: `取消購買`,
  ticket_purchase_total_limit_toast: `一次性購買閱讀券的上限為500,000金幣。`,
  ticket_purchase_shortage: `金幣不足`,
  ticket_purchase_shortage_amount: `不足金幣`,
  more_title_cash_add: `儲值金幣`,
  ticket_purchase_shortage_add_notice: `購買{{value}}以上之金幣，依據應用程式內購政策，可能會多次跳出「App內購買」視窗。`,
  ticket_purchase_successful_rental: `已完成購買 {{value}}張借閱券`,
  ticket_purchase_successful_possession: `已完成購買 {{value}}張收藏券`,
  ticket_purchase_successful_balance_cash: `剩餘金幣：{{value}}金幣`,
  ticket_purchase_regulation: `購買說明`,
  ticket_purchase_regulation_1: `本內容為無法退款之服務，已使用的閱讀券將無法申請退款。但若有未經法定代理人同意之情事，可申請退款。`,
  ticket_purchase_regulation_2: `話次可能因內容發行商之不可抗因素延遲更新，無法以更新延遲為由申請退款。`,
  ticket_purchase_regulation_3: `話次可能因內容發行商之決策變更販售價格，無法以價格變動為由申請退款。`,
  ticket_purchase_regulation_4: `「一次性購買」的作品僅有付費閱讀券可申請退款。`,
  ticket_purchase_regulation_5: `現有借閱券亦包括免費閱讀券。`,
  ticket_purchase_regulation_6: `現有金幣亦包括免費金幣。`,
  ticket_purchase_regulation_7: `「一次性購買」後若獲得免費閱讀券，則可能會產生多餘的閱讀券。`,
  ticket_purchase_regulation_8: `「一次性購買」時，系統會計算尚未閱讀話次後提供專屬購買方案。`,
  ticket_purchase_regulation_9: `若單次購買有額外贈送免費閱讀券的活動, 「一次性購買」時也會贈送相對應數量的免費閱讀券。`,
  ticket_purchase_regulation_10: `購買閱讀券後若申請金幣退款，為收回退款之金幣，已購買但尚未使用的閱讀券亦可能被回收。`,
  more_title_cash_history: `金幣明細`,
  cash_history_add_tab: `儲值明細`,
  cash_history_pass: `CASH PASS VIP`,
  cash_history_pass_banner: `現在加入最高可獲得 {{value}}%金幣回饋`,
  cash_history_pass_benefit: `正在獲得 {{value}}%金幣回饋`,
  cash_history_pass_detail_button: `查看詳情`,
  cash_history_add_purchased: `購買<gold>{{value}}金幣</gold>`,
  cash_history_expiration_date: `{{value}}金幣 即將於{{date}}到期`,
  cash_history_expiration_date_2lines: `{{value}}金幣
即將於{{date}}到期`,
  cash_history_event: `活動 ・ {{campaign}}`,
  cash_history_currency: `NT\${{value}}`,
  cash_history_administrator: `管理者收回`,
  cash_history_administrator_added: `管理者發放`,
  cash_history_store_refunded: `應用程式商店退款收回`,
  cash_history_add_coupon: `登錄優惠券`,
  cash_history_add_coupon_detail: `登錄優惠券 ・ {{campaign}}`,
  cash_history_add_auto_bonus: `自動加值 ・ 贈送{{value}}金幣`,
  cash_history_add_purchased_bonus: `購買金幣 ・ 贈送{{value}}金幣`,
  cash_history_minus_refunded: `取消購買{{value}}金幣`,
  cash_history_minus_purchased: `購買{{value}}金幣`,
  cash_history_added_empty: `尚無自動加值紀錄`,
  cash_history_used_tab: `使用紀錄`,
  cash_history_used_empty: `尚無金幣使用紀錄`,
  more_title_cash_add_auto: `自動加值`,
  cash_add_pass_benefit: `<bold>CASH PASS VIP</bold> 最高 {{value}}% 金幣回饋`,
  cash_add_auto_unapplied: `現在加入最高可獲得 {{value}}%金幣回饋`,
  cash_add_balance: `現有金幣`,
  cash_add_pass: `CASH PASS VIP`,
  cash_add_pass_inuse: `使用中`,
  cash_add_title: `<gold>金幣</gold> 儲值`,
  cash_add_first_purchase_event: `首購優惠活動`,
  cash_add_discount_title: `金幣優惠`,
  cash_add_authentication_popup: `當月結帳額度已達上限，需進行本人認證後方可繼續使用。(未進行本人認證之使用者：每月最高限額5萬元)`,
  cash_add_authentication_button: `認證`,
  cash_add_payment_limit_popup_title: `可交易金額已達上限`,
  cash_add_payment_limit_popup_content: `若超過每月交易上限金額，購買服務將受限制。交易上限將於每月1日0點重新計算。`,
  cash_add_payment_limit_exceed_popup: `已達金幣儲值上限`,
  cash_add_payment_limit_exceed_popup_content: `目前可儲值額度為{{value1}}金幣。
最多可儲值至{{value2}}金幣。`,
  cash_add_payback: `{{value}}金幣 <gold>+ {{bonus}}金幣</gold>`,
  cash_add_item_badge_recommend: `推薦`,
  cash_add_item_badge_popular: `熱門`,
  cash_add_agree_button: `我同意以下使用規範與付款程序。`,
  cash_add_next_button: `下一步`,
  cash_add_guides: `購買須知`,
  cash_add_amount_popup_title: `選擇儲值金幣`,
  cash_add_payment_popup_title: `選擇付款方式`,
  cash_add_payment_popup_button: `結帳`,
  cash_add_payment_processed_toast: `交易進行中，請稍候`,
  cash_add_payment_processed_popup: `交易進行中，最多需要20秒的處理時間，交易結束後將自動關閉本視窗，請稍候`,
  cash_add_success_popup: `{{value}}金幣已儲值完成`,
  cash_add_balance_popup: `現有金幣：{{value}}金幣`,
  cash_add_fail_popup: `{{value}}金幣儲值失敗
請重試一次`,
  cash_add_fail_popup_content: `您的付款資訊無效`,
  cash_add_pending_toast: `交易未完成。請確認google store中的付款方式是否有誤。若無誤，請重新開啟儲值頁面。`,
  cash_add_payment_processing_popup: `交易進行中，請於稍後確認交易資訊`,
  error_unsupported_browser: `目前的瀏覽器不支援本服務，請更新至最新版。`,
  error_unsupported_os: `目前的OS版本不支援本服務，請更新至最新版。`,
  billing_msg_invalid_msg: `錯誤的要求。`,
  billing_msg_invalid_parameter: `要求無效。`,
  billing_msg_service_fail: `發生未知的錯誤。`,
  billing_msg_invalid_required_parameter: `必需的參數不存在。`,
  billing_msg_fail_get_user_info: `使用者資訊查詢失敗。`,
  billing_msg_invalid_user_info: `使用者資訊無效。`,
  billing_msg_invalid_user_region: `目前所在國家的服務資訊有誤。`,
  billing_msg_invalid_billing_hash: `要求的資料驗證失敗。`,
  billing_msg_intro_fail_get_account_balance: `金幣餘額查詢失敗。`,
  billing_msg_intro_fail_get_view_intro: `商品資訊查詢失敗。`,
  billing_msg_intro_payment_policy_not_exist: `付款須知資訊不存在。`,
  billing_msg_intro_payment_item_not_exist: `付款的商品資訊不存在。`,
  billing_msg_request_invalid_price: `欲付款的金額無效。`,
  billing_msg_request_invalid_item_id: `欲付款的商品資訊無效。`,
  billing_msg_request_fail_get_item_info: `商品資訊查詢失敗。`,
  billing_msg_request_item_not_exists: `商品資訊不存在。`,
  billing_msg_request_fail_get_payment_id: `付款資訊登錄失敗。`,
  billing_msg_request_fail_get_pg_url: `付款資訊設定失敗。`,
  billing_msg_result_invalid_pay_info: `付款資訊無效。`,
  billing_msg_result_pg_fail: `儲值失敗。\n請再試一次。`,
  billing_msg_credit_info_not_exists: `交易資訊不存在。`,
  billing_alert_check_agree: `請同意付款須知。`,
  billing_alert_invalid_price: `金額資訊無效。`,
  billing_alert_invalid_item_info: `商品資訊無效。`,
  billing_common_404: `找不到您搜尋的網頁。`,
  billing_msg_already_other_device_login: `因您已在其他裝置登入，系統自動將本裝置登出。`,
  billing_msg_invalid_access_logout: `錯誤的存取，系統已登出。`,
  billing_msg_already_login: `登入後方可使用。`,
  billing_msg_web_unavailable: `金幣僅能透過應用程式儲值，
您要前往應用程式嗎？`,
  billing_msg_pc_unavailable: `金幣僅能透過應用程式儲值，
請安裝應用程式後完成儲值。`,
  billing_msg_first_puchase_only: `可付款的次數已達上限。`,
  library_tab_recent: `最近看過`,
  library_tab_recent_phrase_default: `KAKAO WEBTOON
獨家鉅獻
您怎能錯過`,
  library_tab_recent_phrase_login_genre: `{{userid}}喜歡
{{genre_1}}類作品
所以推薦給您`,
  library_tab_recent_phrase_popular: `大家都在追
{{genre_1}}類作品
快來一起入坑吧`,
  library_tab_recent_phrase_login_title: `{{userid}}喜歡
{{title}}
所以推薦給您`,
  library_tab_recent_phrase_nonlogin_style: `和{{title}}
畫風類似的作品
您應該有興趣`,
  library_tab_recent_phrase_nonlogin_genre: `最近很常看
{{genre_1}}類作品
所以推薦給您`,
  library_tab_recent_phrase_nonlogin_title: `最近很常看
{{title}}
所以推薦給您`,
  library_tab_recent_phrase_title: `您最近很常看
{{title}}`,
  library_tab_recent_phrase_rec: `要不要試試
KAKAO WEBTOON的
其他作品呢？`,
  library_tab_recent_empty: `尚無最近閱讀過的作品`,
  library_see_all_button: `看全部`,
  library_tab_recent_sort_recent: `依閱覽日期`,
  library_tab_recent_sort_update: `依更新日期`,
  library_tab_recent_sort_recent_toast: `依閱覽日期排序`,
  library_tab_recent_sort_update_toast: `依更新日期排序`,
  library_tab_recent_sort_download_toast: `依下載排序`,
  library_tab_recent_sort_storage_toast: `依容量排序`,
  library_edit_button: `編輯`,
  library_select_all_button: `全部選擇`,
  library_delete_episode_button: `刪除{{count}}個話次`,
  library_delete_episode_button_plural: `刪除{{count}}個話次`,
  library_delete_content_button: `刪除{{count}}個作品`,
  library_delete_content_button_plural: `刪除{{count}}個作品`,
  library_tab_recent_delete_popup: `是否要刪除最近閱覽的{{count}}個作品？`,
  library_tab_recent_delete_popup_plural: `是否要刪除最近閱覽的{{count}}個作品？`,
  library_tab_recent_delete_popup_v4: `是否要從最近看過清單中刪除的{{value}}個作品？`,
  library_tab_recent_delete_popup_plural_v4: `是否要從最近看過清單中刪除的{{value}}個作品？`,
  library_tab_recent_language_toast: `該作品可切換成 {{language}}後閱覽`,
  library_tab_recent_language_toast_v4: `目前的語言設定下無法閱讀本作品`,
  library_tab_favorites: `我的最愛`,
  library_tab_favorites_on: `ON`,
  library_tab_favorites_off: `OFF`,
  library_tab_favorites_device_popup: `應用程式通知已關閉。
是否要更改應用程式通知開關？`,
  library_tab_favorites_episode_popup: `是否要開啟話次更新通知，獲得最新消息？`,
  library_tab_favorites_episode_popup_button: `開啟通知`,
  library_tab_favorites_episode_toast: `接收話次更新通知`,
  library_before_login: `登入後方可使用`,
  library_tab_favorites_before_login: `登入後可收藏作品
並接收話次更新通知`,
  library_tab_empty: `收藏感興趣的作品
並接收話次更新通知吧！`,
  library_tab_favorites_available_fav: `已收藏
{{count}}個作品`,
  library_tab_favorites_available_fav_plural: `已收藏
{{count}}個作品`,
  library_tab_favorites_available_update: `已更新
{{count}}個話次`,
  library_tab_favorites_available_update_plural: `已更新
{{count}}個話次`,
  library_tab_favorites_unavailable: `尚未收藏任何作品`,
  library_tab_favorites_sort_update: `依更新日期`,
  library_tab_favorites_sort_added: `依收藏日期`,
  library_tab_favorites_sort_update_toast: `依更新日期排序`,
  library_tab_favorites_sort_added_toast: `依收藏日期排序`,
  library_tab_favorites_delete_title: `編輯`,
  library_tab_favorites_delete_popup: `是否要刪除{{count}}個收藏的作品？`,
  library_tab_favorites_delete_popup_plural: `是否要刪除{{count}}個收藏的作品？`,
  library_tab_downloads: `下載`,
  library_tab_download_available_episode: `已下載
{{count}}個話次`,
  library_tab_download_available_episode_plural: `已下載
{{count}}個話次`,
  library_tab_download_unavailable_series: `尚未下載任何作品`,
  library_tab_download_before_login: `登入後可下載作品，並於離線模式時閱覽。`,
  library_tab_download_empty: `下載作品後可於離線模式時閱覽喔！`,
  library_tab_download_sort_download: `依下載排序`,
  library_tab_download_sort_storage: `依儲存容量排序`,
  library_tab_download_refresh: `重新整理`,
  library_delete_title_button: `刪除{{value}}個作品`,
  library_tab_download_free: `免費`,
  library_tab_download_rent: `借閱`,
  library_tab_download_possess: `收藏`,
  library_tab_download_expired: `借閱已到期`,
  library_tab_download_paid: `已轉換為付費話次`,
  library_tab_download_expired_toast: `借閱期間已到期。重新下載後可再次閱覽。`,
  library_tab_downloads_delete_popup: `是否要刪除{{count}}個已下載的作品？`,
  library_tab_downloads_delete_popup_plural: `是否要刪除{{count}}個已下載的作品？`,
  library_tab_downloads_delete_popup_v4: `是否要刪除{{value}}個已下載的作品？`,
  library_tab_downloads_delete_popup_plural_v4: `是否要刪除{{value}}個已下載的作品？`,
  library_tab_downloads_delete_ep_popup: `是否要刪除{{count}}個已下載的話次？`,
  library_tab_downloads_delete_ep_popup_plural: `是否要刪除{{count}}個已下載的話次？`,
  library_tab_downloads_delete_ep_popup_v4: `是否要刪除{{value}}個已下載的話次？`,
  library_tab_downloads_delete_ep_popup_plural_v4: `是否要刪除{{value}}個已下載的話次？`,
  library_tab_download_offline_toast: `離線模式中無法移動`,
  library_tab_download_network_popup: `請確認網路連線狀態後再試一次。`,
  offline_download_empty_title: `尚未下載任何作品`,
  offline_download_empty_episode: `尚未下載任何話次`,
  offline_download_network_toast: `網路連線後可繼續使用服務`,
  error_network_popup_title: `無法連線至網路`,
  error_network_popup_content: `請檢查飛航模式、Wi-Fi及行動數據，以確認網路連線狀況，並於確認後重試一次。`,
  library_tab_possessed: `已購買的作品`,
  library_tab_possessed_available: `目前有{{count}}個
已購買的話次`,
  library_tab_possessed_available_plural: `目前有{{count}}個
已購買的話次`,
  library_tab_possessed_unavailable_series: `尚未購買任何作品`,
  library_tab_possessed_unavailable_episode: `尚未購買任何話次`,
  library_tab_possessed_sort_update: `依更新日期`,
  library_tab_possessed_sort_possessed: `依購買日期`,
  library_tab_possessed_sort_update_toast: `依更新日期排序`,
  library_tab_possessed_sort_possessed_toast: `依購買日期排序`,
  library_tab_possessed_sort_episode_count: `收藏{{count}}個話次`,
  library_tab_possessed_sort_episode_count_plural: `收藏{{count}}個話次`,
  library_tab_possessed_sort_episode_free: `該話次可免費看`,
  library_tab_possessed_sort_episode_expired: `借閱已到期`,
  library_tab_possessed_empty: `尚未使用閱讀券閱覽任何話次`,
  library_tab_possessed_empty_ticket: `剩{{count}}張閱讀券`,
  library_tab_possessed_empty_ticket_plural: `剩{{count}}張閱讀券`,
  library_tab_possessed_empty_ticket_button: `立即觀賞作品`,
  library_tab_possessed_delete_popup_v4: `該作品已於購買清單中隱藏，
若想取消隱藏，
請利用編輯模式並打開選項。`,
  library_tab_possessed_deleted_toast: `刪除`,
  library_tab_possessed_episode_button: `{{count}}個話次`,
  library_tab_possessed_episode_button_plural: `{{count}}個話次`,
  library_hide_title_button: `隱藏{{count}}個作品`,
  library_hide_title_button_plural: `隱藏{{count}}個作品`,
  library_tab_possessed_delete_popup: `是否隱藏{{count}}個已購買的作品？
若再次購買閱讀券，已隱藏的作品會再次新增至我的漫畫。`,
  library_tab_possessed_delete_popup_plural: `是否隱藏{{count}}個已購買的作品？
若再次購買閱讀券，已隱藏的作品會再次新增至我的漫畫。`,
  library_tab_possessed_before_login: `請確認已購買的作品`,
  library_tab_comments: `留言`,
  library_tab_comments_unavailable: `尚未撰寫留言`,
  library_tab_comments_delete_popup: `您要刪除{{count}}則已撰寫的留言嗎？`,
  library_tab_comments_delete_popup_plural: `您要刪除{{count}}則已撰寫的留言嗎？`,
  giftbox_cashfriend: `目前可獲得的金幣`,
  giftbox_onboarding: `現在立刻註冊
就可獲得人氣作品免費閱讀券！`,
  giftbox_tab_event: `活動`,
  giftbox_tab_event_participated: `已發送`,
  giftbox_tab_event_empty: `目前沒有可參加的活動`,
  giftbox_tab_event_empty_global: `目前沒有
可參加的
活動`,
  giftbox_ticket_gift: `免費
閱讀券`,
  giftbox_tab_ticket_receive_button: `領{{count}}張`,
  giftbox_tab_ticket_receive_button_plural: `領{{count}}張`,
  luckydraw_ticket_button: `立即觀賞作品`,
  giftbox_tab_ticket_received: `已領取`,
  giftbox_tab_ticket_empty: `目前沒有可領取的免費閱讀券`,
  giftbox_tab_ticket_empty_global: `目前沒有
可領取的
免費閱讀券`,
  giftbox_tab_ticket_empty_korea: `目前沒有
可領取的
好禮`,
  giftbox_tab_received_popup: `獲得 {{count}}張免費閱讀券`,
  giftbox_tab_received_popup_plural: `獲得 {{count}}張免費閱讀券`,
  giftbox_tab_received_valid_within_popup: `使用期限：發送日起3天`,
  search_title: `搜尋`,
  search_main_question: `想搜尋
什麼作品呢?`,
  search_main_question_1_web: `想搜尋`,
  search_main_question_2_web: `什麼作品呢?`,
  search_input_before_enter: `請輸入作品名、作者名、類型`,
  search_recent: `最近搜尋`,
  search_recent_plural: `最近搜尋`,
  search_result_empty: `"{{value}}"
找不到符合上述字詞的搜尋結果。`,
  search_result_empty_web: `找不到符合上述字詞的搜尋結果。`,
  notification_title: `通知`,
  notification_tab_my: `我的消息`,
  notification_tab_gidamu: `倒數免費`,
  notification_tab_gidamu_complete: `可免費閱讀一話`,
  notification_before_login: `登入後方可使用`,
  gidamu_notification_list_blank: `目前沒有新通知`,
  notification_list_blank: `目前沒有新消息`,
  notification_tab_notice: `公告`,
  notification_notice_list_deleted: `已刪除的公告`,
  notification_valid_specific_date: `使用期限：至 {{value}}止`,
  notification_expiry_bydate: `使用期限：發送日起 {{count}}天`,
  notification_expiry_bydate_plural: `使用期限：發送日起  {{count}}天`,
  notification_expiry_byhour: `使用期限：發送日起  {{count}}小時`,
  notification_expiry_byhour_plural: `使用期限：發送日起  {{count}}小時`,
  notification_expiry_specific_date: `使用期限：至 {{value}}止`,
  notification_expiry_today: `使用期限：至今日為止`,
  notification_expiry_hour: `使用期限：發送當下至下一個整點前`,
  notification_tab_gidamu_delete_button: `關閉{{count}}個倒數免費通知`,
  notification_tab_gidamu_delete_button_plural: `關閉{{count}}個倒數免費通知`,
  notification_tab_gidamu_delete_popup_title: `確定要關閉{{count}}部作品的倒數免費通知嗎？`,
  notification_tab_gidamu_delete_popup_title_plural: `確定要關閉{{count}}部作品的倒數免費通知嗎？`,
  notification_tab_gidamu_delete_popup_content: `當您使用倒數免費券閱讀作品，將再次收到通知`,
  notification_push_waitandfree_title: `[倒數免費] {{value}}`,
  notification_push_waitandfree_content: `現在馬上免費看一話!`,
  notification_push_ticket_expire_title: `閱讀券已過期`,
  notification_push_ticket_expire_content: `{{title}}的{{count}}張閱讀券於今天到期`,
  notification_push_ticket_expire_content_plural: `{{title}}的{{count}}張閱讀券於今天到期`,
  notification_push_cash_expire_title: `免費金幣即將歸零`,
  notification_push_cash_expire_content: `使用即將到期的免費金幣購買閱讀券!`,
  notification_push_title_update_title: `{{value}} 已更新`,
  notification_push_title_update_content_multiple: `{{start}} ~ {{end}}已更新`,
  notification_push_title_update_content_single: `{{value}}已更新`,
  notification_push_comment_like_title: `{{value}}按您的留言讚`,
  notification_push_comment_like_title_multiple: `{{count}}和其他{{count}}人按您的留言讚`,
  notification_push_comment_like_title_multiple_plural: `{{count}}和其他{{count}}人按您的留言讚`,
  notification_push_comment_reply_title: `有人回覆您的留言`,
  notification_push_comment_reply_content: `[{{content}} - {{episode}}]`,
  notification_push_comment_reply_event_content: `[{{value}}]`,
  notification_push_gift_ticket_content: `已發送免費閱讀券。`,
  notification_push_gift_cash_content: `已發送{{value}}免費金幣。`,
  notification_push_gift_coupon_title: `[優惠券已完成登錄]`,
  notification_push_gift_slot_content: `立即摸彩去`,
  notification_push_gift_luckydraw_title: `中獎好禮已送達`,
  notification_push_gift_prize_title: `已發送{{prize}}。`,
  notification_push_gift_prize_content: `請於領取期限內輸入完成。`,
  notification_push_popup_title_update_deleted: `該作品已無法閱讀`,
  notification_push_popup_event_expired: `活動已結束`,
  notification_push_popup_common_language: `更改語言後無法前往通知頁面。若您想確認通知內容，請重新設定語言。`,
  notification_raffle_page_title: `摸彩券送達`,
  notification_raffle_received: `摸彩券已發送!`,
  notification_raffle_received_name: `摸彩券`,
  notification_raffle_received_date: `發送日`,
  more_menu: `側邊選單`,
  more_login_eng: `Login`,
  more_title_cash_add_auto_applied: `正在獲得 {{value}}%金幣回饋`,
  more_title_cash_add_auto_unapplied: `若開啟自動儲值功能，最多可獲得{{value}}%金幣回饋`,
  more_title_coupon_redeem: `登錄優惠券`,
  more_title_notification: `我的消息`,
  more_title_notice: `公告`,
  more_title_display_mode: `螢幕顯示設定`,
  more_title_display_mode_dark: `深色模式`,
  more_title_display_mode_light: `淺色模式`,
  more_title_display_mode_system: `系統設定`,
  more_title_content_notification: `作品通知設定`,
  more_title_content_notification_before_login: `登入後即可使用`,
  more_title_content_notification_episode: `話次更新通知`,
  more_title_content_notification_gidamu: `倒數免費通知`,
  more_title_system_preferences: `行動數據設定`,
  more_title_system_preferences_autoplay: `自動播放影片`,
  more_title_system_preferences_data: `僅在使用Wi-Fi時閱覽話次`,
  more_title_app_setting: `設定`,
  settings_title_web: `設定`,
  more_login_message: `請登入`,
  more_cash_add_auto_unapplied: `最高可獲得 {{value}}%金幣回饋`,
  more_cashfriends: `現在可獲得金幣`,
  more_myinfo: `關於我`,
  more_myinfo_nickname: `暱稱`,
  more_myinfo_userid: `會員ID`,
  more_myinfo_userid_copy_toast: `已成功複製`,
  more_myinfo_account: `我的帳號`,
  more_myinfo_logout_popup: `確定要登出嗎？`,
  more_myinfo_nickname_unknown: `未知的帳號`,
  more_myinfo_nickname_change: `修改暱稱`,
  more_myinfo_nickname_enter: `請輸入暱稱`,
  more_myinfo_nickname_limit_guide: `<white>{{value}}</white>/20`,
  more_myinfo_nickname_toast: `已成功儲存`,
  more_myinfo_nickname_banned_toast: `{{word}}無法作為暱稱使用`,
  more_myinfo_nickname_emoticon: `可輸入2~20字元以內的中文、英文、數字及特殊文字(-, _為限)`,
  more_myinfo_nickname_change_button: `儲存`,
  more_myinfo_nickname_length: `最多可輸入20字元。`,
  more_myinfo_nickname_character: `可輸入中文、英文、數字及特殊文字(-, _為限)。`,
  more_myinfo_account_delete: `註銷帳號`,
  more_myinfo_account_delete_precautions: `KAKAO WEBTOON註銷帳號注意事項`,
  more_myinfo_account_delete_precautions_detail_1: `註銷帳號後，該帳號的消費紀錄、閱讀券使用紀錄等所有內容將立刻刪除且無法復原。`,
  more_myinfo_account_delete_precautions_detail_2: `註銷帳號後，您的留言會顯示為「該用戶已註銷帳號」。若要刪除留言，請在註銷帳號前自行刪除。`,
  more_myinfo_account_delete_precautions_detail_3: `註銷帳號後，未使用的閱讀券與金幣將自動失效。`,
  more_myinfo_account_delete_precautions_detail_4: `使用應用程式內購儲值的金幣，無法透過KAKAO WEBTOON辦理退款。若要退款，請聯繫應用程式商店(Google Play或App Store)。`,
  more_myinfo_account_delete_precautions_detail_5: `註銷帳號後30日內，無法使用同一帳號再次註冊。`,
  more_myinfo_account_delete_agreed: `我已了解所有注意事項`,
  more_myinfo_account_delete_button: `註銷KAKAO WEBTOON帳號`,
  more_myinfo_account_delete_confirm_popup: `註銷帳號後，您所持有的金幣、閱讀券\n及服務使用紀錄將立刻刪除。\n確定要註銷帳號嗎?`,
  more_myinfo_account_delete_toast: `已註銷帳號`,
  more_help: `幫助`,
  more_help_faq: `常見問題`,
  more_customer: `客服中心`,
  more_customer_rights_report: `侵權申訴說明`,
  more_customer_title_inquiry: `問題回報`,
  more_customer_inquiry: `聯絡我們`,
  more_customer_inquiry_global_title: `[Help] 聯絡KAKAO WEBTOON`,
  more_customer_inquiry_global_question_1: `想問什麼問題呢？ (故障、建議事項、其他)`,
  more_customer_inquiry_global_question_2: `遇到哪些狀況？ (請寫下詳細之故障原因、發生過程、發生頻率等內容，有助於我們更快協助您解決問題。)`,
  more_customer_inquiry_global_question_3: `為了更明確釐清您的問題，若有相關截圖或螢幕錄影請上傳`,
  more_customer_inquiry_info_id: `會員號碼`,
  more_customer_inquiry_info_version_app: `應用程式目前版本`,
  more_customer_inquiry_info_browser: `瀏覽器`,
  more_customer_inquiry_info_device: `裝置名稱`,
  more_customer_inquiry_info_device_language: `裝置使用之語言`,
  more_customer_inquiry_info_version_ios: `iOS Version`,
  more_customer_inquiry_info_version_aos: `Android version`,
  more_customer_inquiry_global_agreement_notice: `當您發送上述電子郵件，即表示您已同意本平台之使用條款與隱私權政策。`,
  more_customer_support_email_address: `support_tw@kakaowebtoon.com`,
  more_customer_support_email_address_th: `cs.th@kakaoent.com`,
  more_customer_support_email_address_tw: `support_tw@kakaowebtoon.com `,
  more_customer_inquiry_category: `選擇問題分類`,
  more_customer_inquiry_category_refund_ticket: `閱讀券退款`,
  more_customer_inquiry_category_refund_cash: `金幣退款`,
  more_customer_inquiry_category_report_rights: `侵權申訴`,
  more_customer_inquiry_category_general: `一般問題`,
  more_customer_inquiry_category_suggestions: `建議事項`,
  more_customer_inquiry_category_problems: `使用時發生問題`,
  more_customer_inquiry_answer_number: `可聯絡的手機號碼`,
  more_customer_inquiry_answer_number_error: `請輸入正確的手機號碼`,
  more_customer_inquiry_answer_email: `可聯絡的電子郵件`,
  more_customer_inquiry_answer_email_error: `請輸入正確的電子郵件`,
  more_customer_inquiry_attachment: `上傳附件`,
  more_customer_inquiry_attachment_button: `上傳`,
  more_customer_inquiry_attachment_detail_2: `檔案僅支援JPG, PNG, PDF, ZIP格式。`,
  more_customer_inquiry_agreement_title: `個人資料收集聲明`,
  more_customer_inquiry_agreement_1: `為回覆您向本公司提出之問題，本公司得蒐集您的電子郵件與手機號碼。`,
  more_customer_inquiry_agreement_check: `同意以上內容`,
  more_customer_inquiry_send_button: `送出`,
  more_customer_inquiry_send_toast: `您的問題已成功傳送`,
  more_customer_inquiry_history: `您的提問`,
  more_customer_inquiry_history_detail: `僅提供檢視最近1年內的提問紀錄`,
  more_customer_inquiry_history_empty: `尚未有提問紀錄`,
  more_serviceinfo: `服務資訊`,
  more_serviceinfo_terms: `服務條款`,
  more_serviceinfo_terms_cookie: `Cookie政策`,
  more_serviceinfo_terms_use: `使用條款`,
  more_serviceinfo_terms_personal: `隱私權政策`,
  more_serviceinfo_openlicense: `Open License`,
  more_serviceinfo_business: `關於我們`,
  more_serviceinfo_business_name_company: `Company name`,
  more_serviceinfo_business_name_corporation: `Kakao Entertainment Corporation`,
  more_serviceinfo_business_name_representative: `Co-CEO`,
  more_serviceinfo_business_name_representative_detail: `Kisu Kweon, Joseph Chang`,
  more_serviceinfo_business_registration_number: `Business registration number`,
  more_serviceinfo_business_registration_number_detail: `220-88-02594`,
  more_serviceinfo_business_mail_order: `Mail-order business report`,
  more_serviceinfo_business_mail_order_detail: `2018-Seongnam Bundang B-0004`,
  more_serviceinfo_business_address: `Address`,
  more_serviceinfo_business_address_detail: `Gyeonggido Seognamsi 
Bundanggu Pangyo 221`,
  more_serviceinfo_business_phone: `Customer service contact number`,
  more_serviceinfo_business_phone_detail: `1644-4755`,
  more_serviceinfo_business_email: `Email address`,
  more_serviceinfo_business_email_detail: `contact@kakaoent.com`,
  more_serviceinfo_business_host: `Service provider`,
  more_serviceinfo_version: `版本說明`,
  more_serviceinfo_version_latest: `最新版本`,
  more_serviceinfo_version_current: `目前版本`,
  more_serviceinfo_version_update: `更新為最新版本`,
  more_serviceinfo_version_latest_inuse: `目前為最新版本`,
  more_serviceinfo_version_minsdk_change_title: `最低系統使用需求說明`,
  more_serviceinfo_version_minsdk_change_content: `為提供更完善的服務，最低系統使用需求調整為{{value}}以上版本。

{{value}}以下之版本將無法進行應用程式更新，日後亦可能無法繼續使用應用程式，造成您的不便，敬請見諒。`,
  more_serviceinfo_version_minsdk_changed_title: `舊版本停止服務支援說明`,
  more_serviceinfo_version_minsdk_changed_content: `您可以透過KAKAO WEBTOON網頁版繼續閱覽作品及取消已購買之閱讀券。造成您的不便，敬請見諒。`,
  more_serviceinfo_version_minsdk_changed_gotoweb: `前往網頁版`,
  redeem_coupon_before_enter: `請輸入優惠券序號`,
  redeem_coupon_before_register_button: `登錄`,
  redeem_coupon_policy: `登錄優惠券注意事項`,
  redeem_coupon_inquiry: `請洽客服中心`,
  redeem_coupon_policy_detail_1: `已到期之優惠券無法進行登錄`,
  redeem_coupon_policy_detail_2: `已登錄之優惠券無法更換、退款及兌現`,
  redeem_coupon_policy_detail_3: `已登錄之優惠券可於「側邊選單 > 金幣明細」中查看`,
  redeem_coupon_policy_detail_3_v4: `已登錄之優惠券可於「側邊選單 > 通知」中查看`,
  redeem_coupon_toast_success: `優惠券已登錄完成，
可於「我的消息」中查看`,
  redeem_coupon_toast_fail_invalid_checkagain: `序號有誤，請重新輸入`,
  redeem_coupon_toast_fail_used: `該序號已被兌換`,
  redeem_coupon_toast_fail_sametype: `同類型之序號僅能登錄1次`,
  redeem_coupon_toast_fail_ineligible: `無法使用該優惠券`,
  redeem_coupon_toast_fail_expired: `優惠券已到期`,
  redeem_coupon_toast_fail_invalid: `此為無效優惠券`,
  redeem_coupon_toast_fail_ranout: `該優惠券使用名額已額滿`,
  redeem_coupon_toast_fail_used_device: `已在同一裝置上領取優惠券`,
  settings_title: `設定`,
  settings_system_preferences: `偏好設定`,
  settings_notifications: `通知設定`,
  settings_notifications_content: `目前已關閉所有通知`,
  settings_notifications_device: `裝置通知設定`,
  settings_notifications_device_detail: `開啟時，可接收應用程式通知`,
  settings_notifications_toast: `開啟裝置通知後方可使用`,
  settings_notifications_aos_toast: `需開啟所有通知方可使用`,
  settings_notifications_ios_popup: `為變更裝置通知設定
將前往裝置中的「設定」`,
  settings_notifications_marketing: `行銷活動及作品推薦通知`,
  settings_notifications_marketing_detail: `允許接收作品推薦與活動通知`,
  settings_notifications_marketing_detail_320: `允許接收作品推薦與活動通知`,
  settings_notifications_marketing_on_toast: `{{value}}同意接收KAKAO WEBTOON的行銷活動及作品推薦通知。`,
  settings_notifications_marketing_on_toast_320: `{{value}}同意接收KAKAO WEBTOON的行銷活動及作品推薦通知。`,
  settings_notifications_marketing_off_toast: `{{value}}拒絕接收KAKAO WEBTOON的行銷活動及作品推薦通知。`,
  settings_notifications_marketing_off_toast_320: `{{value}}拒絕接收KAKAO WEBTOON的行銷活動及作品推薦通知。`,
  settings_notifications_device_off: `您的裝置尚未開啟通知\n 請重新設定`,
  settings_notifications_login_toast: `登入後方可使用`,
  settings_notifications_updates: `話次更新通知`,
  settings_notifications_updates_detail: `我的最愛漫畫更新時會收到通知`,
  settings_notifications_ticket: `倒數免費券倒數完成通知`,
  settings_notifications_likes_comment_global: `留言按讚通知`,
  settings_notifications_likes_reply_global: `留言回覆通知`,
  settings_notifications_likes_reply_global_320: `留言回覆通知`,
  settings_notifications_sleepmode_global: `睡眠模式`,
  settings_notifications_sleepmode_global_info: `已設定的時間內不會收到通知。`,
  settings_notifications_sleepmode_global_start: `睡眠模式開始時間`,
  settings_notifications_sleepmode_global_end: `睡眠模式結束時間`,
  settings_notifications_sleepmode_global_pm: `下午 {{time}}`,
  settings_notifications_sleepmode_global_am: `上午 {{time}}`,
  settings_data: `行動數據設定`,
  settings_data_wifi_view: `僅在使用Wi-Fi時閱覽話次`,
  settings_data_wifi_download: `僅在使用Wi-Fi時下載話次`,
  settings_autoplay: `影片自動播放設定`,
  settings_autoplay_on: `開啟`,
  settings_autoplay_off: `關閉`,
  login_register_device_popup: `欲登錄裝置
請先登入。`,
  settings_device_empty: `尚未登錄裝置`,
  settings_device_registered: `目前已登錄{{value}}個`,
  settings_device_register: `登錄裝置`,
  settings_device_deregister: `註銷裝置`,
  settings_device_register_success_toast: `已成功登錄裝置`,
  settings_device_register_fail_toast: `裝置登錄失敗，請再試一次。`,
  settings_device_registered_toast: `此裝置已被登錄，請再試一次。`,
  settings_device_deregister_toast: `已成功註銷裝置`,
  settings_device_register_continue_popup_title: `是否註銷已登錄裝置？`,
  settings_device_register_continue_popup_content: `將扣除本月可註銷裝置次數`,
  settings_device_register_impossible_popup: `本月可註銷裝置次數已達上限，無法再進行註銷。`,
  settings_device_detail_1: `欲下載話次請先登錄裝置。`,
  settings_device_detail_2: `每個ID僅能登錄兩台裝置。`,
  settings_device_detail_3: `註銷裝置每月僅限1次。(可註銷次數剩餘{{value}}次)`,
  settings_device_detail_4: `本月可註銷裝置次數若達上限，須待次月1日方可進行登錄/註銷裝置。`,
  settings_device_info_in_use_registered: `正在使用已登錄的裝置`,
  settings_device_info_in_use_unregistered: `正在使用未登錄的裝置`,
  settings_device_registered_date: `{{date}} 登錄`,
  settings_device_info_deregister_button: `註銷`,
  settings_tracking_ios: `追蹤許可設定`,
  settings_tracking_ios_popup: `開啟追蹤許可
可參加更多活動。
是否要開啟追蹤許可？`,
  settings_tracking_on_ios_toast: `可至裝置中的
「設定 > KAKAO WEBTOON」中
變更追蹤許可設定。`,
  settings_tracking_on_ios_oldversion_toast: `本功能僅支援ios 14以上版本。`,
  settings_language: `語言設定`,
  settings_language_popup_title: `是否更改語言為{{language}}？`,
  settings_language_popup_content: `可閱覽的作品可能有所差異。`,
  settings_language_popup_content_app: `變更語言後，可閱覽的作品可能有所差異，
欲變更語言需重新執行應用程式。`,
  settings_language_popup_content_web: `變更語言後，可閱覽的作品可能有所差異。`,
  region_language_change_settings_popup: `欲變更語言需重新執行應用程式。`,
  settings_manage_space: `管理儲存容量`,
  common_stroage_used_kb: `<bold>{{used}} KB</bold> / {{max}} GB`,
  common_stroage_used_mb: `<bold>{{used}} MB</bold> / {{max}} GB`,
  common_stroage_used: `<bold>{{used}} GB</bold> / {{max}} GB`,
  settings_manage_space_delete_downloads_button: `刪除所有下載內容`,
  settings_manage_space_delete_downloads_popup_title: `是否刪除全部已下載的內容？`,
  settings_manage_space_delete_downloads_popup_content: `欲個別刪除內容請至「我的漫畫 > 下載」中進行`,
  settings_manage_space_delete_cash_button: `刪除暫存內容`,
  settings_manage_space_delete_cash_toast: `已刪除所有暫存內容`,
  settings_manage_space_autodelete: `自動刪除設定`,
  settings_manage_space_autodelete_10d: `10天`,
  settings_manage_space_autodelete_popup_title: `是否將自動刪除的天數更改至10天？`,
  settings_manage_space_autodelete_popup_content: `更改後，已下載的內容會於10天後刪除。`,
  settings_viewer: `閱覽作品設定`,
  settings_viewer_sort: `話次排序設定`,
  settings_viewer_sort_date: `依更新日期排序`,
  settings_viewer_sort_episode: `從第一話開始`,
  settings_viewer_type: `話次檢視模式`,
  settings_viewer_type_thumbnai: `以縮圖檢視`,
  settings_viewer_type_list: `以清單檢視`,
  settings_viewer_resolution: `閱覽器畫質設定`,
  settings_viewer_resolution_high: `高畫質`,
  settings_viewer_resolution_low: `低畫質`,
  settings_display_mode: `螢幕顯示設定`,
  settings_display_mode_dark: `深色模式`,
  settings_display_mode_light: `淺色模式`,
  settings_display_mode_system: `系統設定`,
  login_auto_toast: `自動登入中，請稍後再試。`,
  login_adult_toast: `本作品含有不適合青少年觀看之內容，無法閱覽。`,
  login_popup: `登入後方可使用`,
  login_action_adult_popup: `欲閱覽18禁作品
請先登入。`,
  login_action_view_gidamu_episode_popup: `欲使用倒數免費券免費閱覽
請先登入。`,
  login_action_view_next_ep_popup: `欲繼續閱覽
請先登入。`,
  deleted_account_popup: `此帳號為已註銷之帳號。
註銷後30日內無法再次註冊。`,
  inactive_user_popup_title: `欲登入帳號，請先解除休眠狀態。`,
  inactive_user_popup_content: `超過1年未登入，您的帳號已轉為休眠狀態。請按下確定鍵，解除休眠狀態，即可登入。`,
  blocked_user_popup_title: `基於營運政策，登入功能受限。`,
  blocked_user_popup_content: `欲確認無法登入之原因或欲解除登入限制，請洽客服中心。`,
  blocked_user_popup_content_cs: `<link_cs>前往</link_cs> KAKAO WEBTOON客服中心`,
  new_user_login_popup_web: `您是新會員嗎?
透過應用程式註冊即送好禮!`,
  new_user_login_popup_button_web: `透過應用程式註冊`,
  new_user_login_popup_continue_web: `繼續`,
  login_global_onboarding_popup: `欲使用KAKAO WEBTOON
請先註冊/登入。`,
  login_global_gidamu_popup: `欲使用倒數免費券閱覽作品
請先登入。`,
  login_global_popup: `欲使用本服務，請先登入。`,
  login_global_existing_account_popup: `曾以{{existing}}登入`,
  login_global_account_google: `使用Google帳號登入`,
  login_global_account_apple: `使用Apple帳號登入`,
  login_global_account_facebook: `使用Facebook帳號登入`,
  login_global_account_line: `使用Line帳號登入`,
  login_global_account_twitter: `使用Twitter帳號登入`,
  login_global_existing_other_option_button: `選擇其他方式`,
  login_global_existing_different_signin_button: `使用其他帳號登入`,
  login_global_create_account_popup: `繼續註冊帳號`,
  login_global_have_account_popup: `已經有帳號？`,
  login_signin_button: `登入`,
  login_signup_page_title: `使用條款`,
  login_signup_description_title: `加入KAKAO WEBTOON`,
  login_signup_description_content: `數不盡的故事等著您發現！`,
  login_signup_agree_all: `全部同意`,
  login_new_signup_button: `立即註冊 KAKAO WEBTOON`,
  login_global_signup_agree_termsofuse: `我同意KAKAO WEBTOON的使用條款。 <grey>(必填)</grey>`,
  login_global_signup_termsofuse_page_title: `使用條款`,
  login_global_signup_agree_privacy: `我同意KAKAO WEBTOON的隱私權政策。<grey>(必填)</grey>`,
  login_global_signup_privacy_page_title: `隱私權政策`,
  login_global_signup_agree_required_sentence: `欲完成註冊請先同意上述條款。`,
  login_another_device_popup: `已在其他裝置登入。
是否要註銷其他裝置，以現有裝置登入？`,
  login_global_signedup_web: `此帳號已在其他語言版本進行註冊。您要前往該語言版本的網頁嗎?`,
  login_global_signedup_web_button: `前往`,
  login_global_signedup_app: `目前所在的語言版本與您註冊時所選不同，須變更語言設定。請重新執行應用程式。`,
  login_global_signedup_app_button: `重新執行`,
  login_global_signedup_region_popup: `本帳號註冊的地區為{{region}}，您要使用註冊地區的版本嗎？變更地區時將終止應用程式。`,
  login_global_signedup_region_popup_button: `變更地區`,
  region_country_select_taiwan: `台灣`,
  region_country_select_thailand: `ไทย`,
  region_country_select_france: `法國`,
  region_country_select_indonesia: `Indonesia`,
  region_country_select_korea: `한국`,
  login_forced_logout_popup: `因您已在其他裝置登入，系統自動將本裝置登出。`,
  login_restricted_popup_title: `登入及註冊功能暫時受限。`,
  login_restricted_popup_content: `該裝置短時間內曾登入多個帳戶，基於保護帳戶個資安全，系統將限制登入功能。請使用已登入過的帳戶；欲登入新註冊帳戶，請洽客服中心。`,
  login_restricted_help_popup: `需要協助嗎？<bold-link_cs>聯絡我們</bold-link_cs>`,
  login_adult_verify_popup: `本作品因含有不適合青少年觀看之內容，18歲以上才可閱覽。是否已滿18歲？`,
  error_code_3000_toast: `為更新帳號認證資訊，請重新登入。`,
  login_blocked_toast: `嘗試登入的次數過多，目前無法登入，請稍後再試。`,
  login_global_withdraw_consent_popup_title: `此帳號為不同意「個人資料蒐集」之帳號`,
  login_global_withdraw_consent_popup_content: `基於用戶要求，此帳號為不同意「個人資料蒐集」之帳號。登出後，若要再次登入，必須重新同意使用條款。`,
  login_global_reconsent_title: `欲使用KAKAO WEBTOON，
請先同意使用條款。`,
  authentication_global_popup_title: `請輸入出生年月日方可閱覽`,
  authentication_global_popup_content: `本作品含有不適合青少年觀看之內容，滿18歲以上方可閱覽，請輸入出生年月日進行年齡認證。`,
  authentication_global_adult_toast: `18歲以上方可閱覽。`,
  authentication_global_succeed_adult_toast: `已完成{{n}}歲年齡認證。`,
  authentication_global_failed_adult_toast: `本作品需滿18歲以上方可閱覽。`,
  authentication_global_confirm_popup_content: `您的出生年月日為{{value}}。
是否要進行年齡認證？`,
  luckydraw_title_slot: `幸運拉霸機`,
  luckydraw_title_box: `幸運好禮`,
  luckydraw_title_web: `幸運抽獎券`,
  luckydraw_start: `開始`,
  luckydraw_win: `中獎`,
  luckydraw_win_prize: `中獎`,
  luckydraw_participated: `已參加`,
  luckydraw_winning_gift: `好禮`,
  luckydraw_date_received: `發送日`,
  luckydraw_expiry: `使用期限`,
  luckydraw_expiry_date: `發送日起 {{count}}天`,
  luckydraw_expiry_date_plural: `發送日起 {{count}}天`,
  luckydraw_expiry_hour: `發送當下起 {{count}}小時`,
  luckydraw_expiry_hour_plural: `發送當下起 {{count}}小時`,
  luckydraw_expiry_specific: `至{{value}}止`,
  luckydraw_expiry_today: `至今日為止`,
  luckydraw_expiry_hour_1: `發送當下至下一個整點前`,
  luckydraw_expired: `幸運拉霸機
參與時間已過期。`,
  luckydraw_expired_box: `幸運盒子
參與時間已過期。`,
  luckydraw_win_cash: `抽中金幣`,
  luckydraw_win_cash_amount: `抽中{{value}}金幣`,
  luckydraw_ticket_title: `作品名`,
  luckydraw_win_ticket_amount: `抽中免費閱讀券{{count}}張`,
  luckydraw_win_ticket_amount_plural: `抽中免費閱讀券{{count}}張`,
  luckydraw_prize_notice: `注意事項`,
  luckydraw_prize_notice_1: `資料送出後將無法進行修改。`,
  luckydraw_prize_notice_2_specific: `若未在 {{date}} 內輸入個人資料將取消中獎資格。`,
  luckydraw_prize_notice_2: `若未在中獎後的 {{date}} 前輸入個人資料將取消中獎資格。`,
  luckydraw_prize_notice_3: `為確保個人資料的正確性，我們將另行與中獎者聯繫。若無法聯繫上中獎者或提供的個人資訊有誤，將取消中獎資格。`,
  luckydraw_global_enterinfo: `填寫領獎人資料`,
  luckydraw_global_title: `填寫領獎人資料`,
  luckydraw_global_enterinfo_prize: `請輸入領取{{prize}}的資料。`,
  luckydraw_global_enterinfo_placeholder: `請輸入內容`,
  luckydraw_global_enterinfo_button_submit: `送出`,
  luckydraw_global_enterinfo_button_expired: `已到期`,
  luckydraw_global_enterinfo_button_submitted: `已送出`,
  luckydraw_global_entered_popup: `已填寫領獎人資訊。`,
  crm_ticker_button: `確定`,
  crm_bottom_event_period: `活動期間`,
  crm_bottom_reward_title: `獎項發送說明`,
  crm_bottom_notice: `注意事項`,
  crm_comment_button: `輸入留言`,
  crm_comment_count: `看 {{count}}則留言`,
  crm_comment_count_plural: `看 {{count}}則留言`,
  crm_advance_reservation_button: `事前預約`,
  crm_advance_reservation_toast: `已完成事前預約`,
  crm_advance_reservation: `事前預約`,
  crm_advance_reservation_button_v4: `申請`,
  crm_attendance_status_count: `{{count}}/{{max}} 簽到`,
  crm_attendance_status_not_participated: `尚未參與`,
  crm_attendance_status_participating: `進行中`,
  crm_attendance_status_participated: `已參與`,
  crm_attendance_status_toast: `已完成簽到活動`,
  crm_attendance_status_day: `第{{value}}天話次簽到`,
  crm_attendance_status_day_v4: `已簽到{{value}}話次`,
  crm_attendance_status_day_short: `第{{value}}天話次簽到`,
  crm_attendance_reward_slot_ticket: `立刻發送抽獎券！`,
  crm_attendance_reward_gift_ticket: `發送免費閱讀券！`,
  crm_attendance_reward_cash: `發送{{value}}金幣！`,
  crm_attendance_button_before: `簽到`,
  crm_attendance_button_complete: `簽到成功`,
  crm_attendance_advance_register: `早鳥預約`,
  crm_attendance_advance_register_button: `申請`,
  crm_attendance_advance_registered_toast: `已完成早鳥預約`,
  crm_attendance_advance_register_button_before: `早鳥預約`,
  crm_attendance_advance_register_button_after: `申請成功`,
  crm_push_mission_title: `推播通知說明`,
  crm_push_mission_content: `為獲得更多活動消息，請開啟推播通知。`,
  crm_push_on_toast: `推播通知設定完成`,
  crm_push_on: `開啟通知`,
  crm_push_on_button: `ON`,
  crm_fav_notification_popup_title: `已成功新增至我的最愛`,
  crm_fav_notification_popup_content: `更新時會發送推播通知。
您可以在「我的漫畫 > 我的最愛」管理推播通知。`,
  crm_recommend_not_sale: `該作品尚未開始販售，請稍後再試。`,
  crm_quiz_before_enter: `請輸入答案`,
  crm_quiz_submit_button: `送出`,
  crm_quiz_submit_complete_button: `已送出`,
  crm_quiz_correct_answer_popup: `恭喜答對！
已發送{{reward}}。`,
  crm_quiz_correct_answer_raffle_popup: `恭喜答對！
已獲得摸彩資格。`,
  crm_quiz_incorrect_answer_popup: `好可惜，答錯了。
請再挑戰一次！`,
  crm_quiz_hint: `小提示`,
  crm_quiz_answer_exceed_toast: `留言已超過限制字數`,
  crm_share_button: `立即分享`,
  share_invitation_code_popup: `立即分享邀請序號給好友。`,
  special_title: `強檔鉅獻`,
  mainhome_special_contenthome_button: `立即觀賞作品`,
  mainhome_popup_version_update_mandatory_title: `最新版本更新說明`,
  mainhome_popup_version_update_mandatory_content: `為提供更完整的功能與完善的KAKAO WEBTOON使用體驗，必須將應用程式更新至最新版本。`,
  mainhome_popup_version_update_optional_title: `更新說明`,
  mainhome_popup_version_update_optional_content: `更新至最新版本可提供更穩定的服務。
更新至最新版本約需1分鐘，更新後可立即使用最新服務。`,
  mainhome_popup_permission_title: `KAKAO WEBTOON使用建議`,
  mainhome_popup_permission_content: `使用應用程式時需強制設定以下權限`,
  mainhome_popup_version_keep_button: `使用目前版本`,
  mainhome_popup_version_exit_button: `關閉應用程式`,
  mainhome_popup_participate_button: `參加`,
  mainhome_popup_dontshow_button: `不再顯示`,
  mainhome_popup_view_detail_button: `查看詳情`,
  mainhome_popup_more_button: `看更多`,
  error_server_toast: `資料加載失敗。`,
  error_server_popup_request: `無法完成要求。請再試一次。`,
  mainhome_popup_idfa_ko: `同意追蹤許可將減少不必要的廣告，僅出現您感興趣之內容。若不同意追蹤許可，將隨機出現各類廣告。`,
  mainhome_popup_idfa_global: `用戶資料將被使用，以提供您更好的個人化行銷廣告體驗。`,
  mainhome_display_mode_popup_title: `選擇喜愛的螢幕顯示模式`,
  mainhome_display_mode_popup_content: `提供深色與淺色外觀，
您可於兩種模式中選擇喜愛的風格。`,
  mainhome_display_mode_popup_button: `前往設定`,
  badge_new: `N`,
  badge_up: `UP`,
  badge_today: `今日`,
  badge_new_season: `N`,
  badge_ongoing: `連載`,
  badge_completed: `完結`,
  badge_hiatus: `停更`,
  badge_completed_season: `季完結`,
  badge_brand: `Brand Webtoon`,
  badge_alive: `ALIVE`,
  badge_mon: `一`,
  badge_tue: `二`,
  badge_wed: `三`,
  badge_thu: `四`,
  badge_fri: `五`,
  badge_sat: `六`,
  badge_sun: `日`,
  badge_not_available: `停止販售`,
  badge_mon_long: `一`,
  badge_tue_long: `二`,
  badge_wed_long: `三`,
  badge_thu_long: `四`,
  badge_fri_long: `五`,
  badge_sat_long: `六`,
  badge_sun_long: `日`,
  badge_free: `免費`,
  badge_rent: `借閱`,
  badge_possess: `收藏`,
  badge_comment_creator: `CREATOR`,
  badge_comment_best: `BEST`,
  onboarding_next_button: `下一步`,
  onboarding_start_button: `開始`,
  onboarding_start_without_login: `訪客模式`,
  onboarding_start: `您好，
歡迎來到
KAKAO WEBTOON。`,
  onboarding_skip_popup_title: `等等！這裡還有新用戶專屬的
專屬註冊禮等著您。`,
  onboarding_skip_popup_content: `馬上加入會員，
即可獲得推薦作品的免費閱讀券。`,
  onboarding_skip_comfirm: `前往首頁`,
  onboarding_genre_title: `選擇您喜歡的作品類型，
我們將會向您推薦
您感興趣的作品。`,
  onboarding_content_title: `恭喜您獲得KAKAO WEBTOON免費閱讀券！`,
  bridgepage_description: `立刻下載KAKAO WEBTOON
挖掘更多網漫神作`,
  bridgepage_web_button: `我想繼續使用網頁版`,
  bridgepage_app_button: `下載KAKAO WEBTOON`,
  bridgepage_language_change: `因語言設定不一致而發生異常錯誤`,
  error_network_popup_ios: `無法開啟應用程式，請重試一次。`,
  offline_no_connection_popup: `尚未連接網路。
是否要使用離線模式？`,
  offline_no_connection_popup_exit_button: `關閉應用程式`,
  error_api_call_toast: `無法完成要求。請再試一次。`,
  offline_enter_button: `開啟離線模式`,
  offline_no_connection_toast: `尚未連接網路。
請確認網路連線狀態。`,
  offline_convert_online_popup: `網路已連線。
是否要轉換為連線模式？`,
  offline_enter_online_mode: `連線模式`,
  offline_download_tab_title: `下載`,
  offline_rental_expired_toast: `借閱期限已到期`,
  error_region_unmatch_app_popup: `您目前所在的國家無法使用本服務。
請重新安裝應用程式，並點選該帳號註冊時選擇的國家，即可繼續使用本服務。`,
  error_region_unmatch_web_popup: `您目前所在的國家無法使用本服務。
請點選該帳號註冊時選擇的國家，即可繼續使用本服務。`,
  error_server_common_toast: `發生問題，請稍候再試。`,
  error_server_duplicate_request_toast: `正在處理您的要求。`,
  error_version_popup_contents: `目前版本無法支援此功能。請至App Store更新後繼續使用。`,
  error_page_not_found: `找不到網頁。`,
  error_not_found: `找不到您搜尋的網頁。`,
  block_service_check_title: `系統維護通知`,
  block_service_check_content: `為提供穩定服務，我們將進行系統維護。維護期間無法正常使用應用程式，敬請見諒。我們將致力提供更完善的服務。謝謝。`,
  block_service_check_date_range: `系統維護時間 {{start}} ~ {{end}}`,
  error_event_expired_popup: `本活動已結束`,
  error_event_expired_toast: `活動已結束，無法再參與。`,
  error_event_participate_popup: `您未符合本活動參與資格。`,
  error_cash_fail_aos: `於Google Play結帳時發生了問題。請前往Google Play，刪除檔案與暫存資料，或取消待結帳商品後再試一次。`,
  error_cash_fail_aos_button: `從設定中刪除`,
  android_tampering_popup_title: `查驗到偽造的應用程式，已終止服務。`,
  android_tampering_popup_content: `刪除應用程式並透過官方商店重新下載後，若發生相同情形，請洽KAKAO WEBTOON客服中心。`,
  android_error_connection: `無法載入頁面。\n請確認網路連線狀態後再試一次。`,
  android_error_temporary: `發生暫時性的錯誤，無法載入頁面。`,
  android_error_webview: `WebView發生問題。請重新執行。`,
  js_alert_leave_title: `確定`,
  leave_this_page: `離開此網站`,
  stay_this_page: `停留此頁面`,
  question_leave_this_page: `確定要離開此頁面嗎？`,
  ssl_warnings_header: `此網站的安全性憑證有問題。`,
  ssl_continue: `繼續`,
  security_warning: `安全性警告`,
  view_certificate: `查看憑證`,
  ssl_go_back: `下一步`,
  android_back_button_quit_toast: `再按一次下一步，結束執行。`,
  ssl_untrusted: `此網站出示的安全性憑證並非由信任的憑證授權單位所發行。`,
  ssl_mismatch: `網站名稱與憑證不一致。`,
  ssl_expired: `此網站出示的安全性憑證已過期。`,
  ssl_not_yet_valid: `此網站出示的安全性憑證尚未生效。`,
  ssl_date_invalid: `此網站出示的安全性憑證日期尚未生效。`,
  ssl_invalid: `無效的憑證。`,
  ssl_unknown: `未知的憑證錯誤。`,
  ssl_certificate: `安全性憑證`,
  ssl_certificate_is_valid: `有效的憑證。`,
  page_info: `網頁資訊`,
  page_info_view: `查看網頁資訊`,
  page_info_address: `地址：`,
  issued_to: `發行對象：`,
  common_name: `姓名：`,
  org_name: `組織名稱：`,
  org_unit: `組成單位：`,
  issued_by: `發行機關：`,
  validity_period: `有效期間：`,
  issued_on: `發行日期：`,
  expires_on: `失效日期：`,
  serial_number: `編號：`,
  sha256_fingerprint: `SHA-256指紋：`,
  sha1_fingerprint: `SHA-1指紋：`,
  message_webview_certificate_transparency: `欲解決安全性憑證問題，請更新WebView應用程式。`,
  popup_window_attempt: `是否允許本網站顯示彈跳視窗？`,
  webview_allow: `允許`,
  webview_block: `封鎖`,
  webview_update: `更新`,
  webview_ok: `確定`,
  webview_cancel: `取消`,
  webview_login: `登入`,
  js_alert_title: `'{{value}}' 頁面內容：`,
  notification_category_download: `下載通知`,
  notification_category_common: `一般通知`,
  notification_channel_download: `允許接收話次下載通知`,
  notification_channel_common: `允許接收話次更新、倒數免費、最新活動消息等通知`,
  android_battery_optimization_popup_contents: `若想在未使用應用程式時，於背景執行話次下載，請從「設定」>「電池效能最佳化」頁面關閉「KAKAO WEBTOON」最佳化`,
  multilingual_redeem_code_popup: `應用程式目前的語言設定，無法登錄該優惠券。`,
  footer_customer_service: `客服中心`,
  footer_business_info: `關於我們`,
  footer_terms_of_use: `使用條款`,
  footer_privacy: `隱私權政策`,
  footer_inquiry: `聯絡我們`,
  footer_copyright: `© KAKAO WEBTOON`,
  footer_cookie_policy: `Cookie政策`,
  region_unsupported_title: `您的國家不支援本服務`,
  region_unsupported_content: `應用程式目前尚未支援您所在的國家。
請變更國家設定。
選擇後將無法更改。`,
  region_unsupported_exit_button: `關閉應用程式`,
  region_country_select: `變更國家設定`,
  region_country_select_english: `English`,
  region_language_different_popup: `需變更為所在國家支援的語言。應用程式將重新執行。`,
  region_restart_button: `重新執行`,
  region_language_select_popup: `需變更為所在國家支援的語言。請選擇應用程式中欲使用的語言。`,
  region_language_restart_toast: `需變更為所在國家支援的語言。請重新執行應用程式。`,
  region_select_region_popup_title: `請選擇欲使用服務之國家`,
  region_select_region_popup_title_v4: `請選擇欲使用服務之語言`,
  region_select_region_popup_content: `請選擇欲使用服務之國家，\n選擇後將無法更改。`,
  region_select_region_popup_content_v4: `請選擇欲使用服務之語言，\n選擇後將無法更改。`,
  invitation_guest_welcome_popup_title: `歡迎來到KAKAO WEBTOON`,
  invitation_guest_welcome_popup_content: `- 邀請好禮僅提供給活動對象。
- 活動相關之詳細說明，請於「禮物盒」 > 「活動頁」中確認。
- 邀請用戶與受邀用戶若為同一裝置，恕不提供邀請好禮。`,
  invitation_guest_welcome_popup_button: `立即登入並領取邀請好禮`,
  invitation_guest_expired_popup_title: `活動已結束`,
  invitation_guest_login_popup: `透過以下方式完成登入後，即可獲得好友邀請獎勵!`,
  invitation_guest_target_popup_title_new: `恭喜您註冊成功!`,
  invitation_guest_target_popup_title_return: `歡迎回到KAKAO WEBTOON!`,
  invitation_guest_target_popup_content: `- 符合活動條件時才會提供獎勵。
- 獎勵明細請於 「通知」 > 「我的消息」中確認。`,
  invitation_guest_nontarget_popup_title: `您不符合活動資格`,
  invitation_guest_nontarget_popup_content_return: `本活動僅供未曾註冊KAKAO WEBTOON之新用戶參加。
感謝您使用KAKAO WEBTOON。`,
  invitation_guest_nontarget_popup_content_new: `本活動僅供特定期間內未使用KAKAO WEBTOON之用戶參加。
感謝您使用KAKAO WEBTOON。`,
  invitation_guest_nontarget_popup_content_active: `本活動僅供未曾註冊KAKAO WEBTOON之新用戶，或特定期間內未使用KAKAO WEBTOON之用戶參加。
感謝您使用KAKAO WEBTOON。`,
  invitation_guest_nontarget_popup_content_device: `您不符合好友邀請活動資格。
邀請用戶與受邀用戶若為同一裝置，恕不提供邀請好禮。
感謝您使用KAKAO WEBTOON。`,
  invitation_host_status_count: `邀請{{count}}/{{max}}人`,
  invitation_host_status_participating: `進行中`,
  invitation_host_status_participated: `已參與`,
  invitation_host_link_share_button: `分享邀請連結`,
  invitation_host_link_share_popup_title: `分享`,
  invitation_host_link_share_popup_content: `立刻分享邀請序號`,
  invitation_host_link_copied_toast: `已複製邀請連結
可自由轉貼分享給好友`,
  invitation_host_code_share_button: `複製邀請序號`,
  invitation_host_code_share_toast: `邀請序號：{{code}}
序號已複製`,
};